// File: src/pages/SalesLead.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  Input,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Alert,
  Form,
  Label,
} from "reactstrap";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import swal from "sweetalert";

import {
  FaPlus,
  FaUpload,
  FaFilePdf,
  FaFileExcel,
  FaSlidersH,
  FaClipboardList,
  FaCheck,
  FaTimes,
  FaEye,
  FaEdit,
} from "react-icons/fa";
import { Trash2 } from "react-feather";

import Multiselect from "multiselect-react-dropdown";

// ---------- Shared layer (per your structure in ../import/) ----------
import SuperAdminUI from "../import/SuperAdminUI";
import { CheckPermission } from "../import/CheckPermission";
import { exportDataToPDF } from "../import/Downloader";

import {
  _Get,
  _PostSave,
  _DeleteAll,
  _DeleteByUrl,
  _BulkUpload,
  _Put,
  _GetByUrlOnly,
} from "../import/ApiEndPoint/ApiCalling";

import {
  AssignTo_Sales_Person,
  Bulk_Upload_Lead_Customer,
  Bulk_Upload_VIEW_LEAD_PARTY,
  Create_Account_List,
  Customer_UnLink_Unassign,
  Create_Sales_Lead,
} from "../import/ApiEndPoint/Api";

/* =========================
   CSS (One-row bar but NOT sticky)
========================= */
const CSS_PAGE = `
  /* ❌ NOT STICKY NOW */
  .sl-sticky-wrap{
    position: relative;
    top: auto;
    z-index: 1;
    background: transparent;
  }

  .sl-sticky-card{
    border-radius: 14px;
    border: 1px solid #e5e7eb;
    background: #f4f7f6;
    box-shadow: 0 10px 18px rgba(0,0,0,0.06);
  }

  /* ✅ one row, always */
  .sl-stickybar{
    display:flex;
    align-items:center;
    gap:10px;
    flex-wrap:nowrap;
    overflow-x:auto;       /* if small screen, scroll INSIDE bar only */
    padding: 8px 10px;
    -webkit-overflow-scrolling: touch;
  }
  .sl-stickybar::-webkit-scrollbar{ height: 6px; }
  .sl-stickybar::-webkit-scrollbar-thumb{ background:#e5e7eb; border-radius:999px; }

  .sl-tabs{
    display:flex;
    align-items:center;
    gap:8px;
    flex-wrap:nowrap;
    white-space:nowrap;
  }

  .sl-tab{
    height:30px;
    border-radius:999px;
    border:1px solid #e5e7eb;
    background:#fff;
    color:#0f172a;
    font-weight:900;
    padding:0 10px;
    display:inline-flex;
    align-items:center;
    gap:6px;
    cursor:pointer;
    user-select:none;
  }
  .sl-tab.active{
    background: rgb(8, 91, 245);
    border-color: rgb(8, 91, 245);
    color:#fff;
  }

  .sl-count{
    background:#eef2ff;
    color:#3730a3;
    font-weight:900;
    border-radius:999px;
    padding:2px 7px;
    font-size:12px;
  }
  .sl-tab.active .sl-count{
    background: rgba(255,255,255,.18);
    color:#fff;
  }

  .sl-field{
    display:flex;
    flex-direction:column;
    gap:4px;
    min-width: 170px;
  }
  .sl-field label{
    font-size: 11px;
    font-weight: 900;
    margin: 0;
    color:#0f172a;
    white-space:nowrap;
  }

  .sl-input, .sl-select{
    height:30px;
    border-radius:10px;
    border:1px solid #e5e7eb;
    background:#fff;
    font-weight:900;
    padding: 6px 10px;
    min-width: 170px;
  }

  .sl-iconbtn{
    height:30px;
    width:34px;
    border-radius:10px;
    border:1px solid #e5e7eb;
    background:#fff;
    display:inline-flex;
    align-items:center;
    justify-content:center;
    cursor:pointer;
    box-shadow: 0 6px 12px rgba(0,0,0,0.04);
    flex: 0 0 auto;
  }
  .sl-iconbtn:hover{
    box-shadow: 0 10px 18px rgba(0,0,0,0.08);
    transform: translateY(-1px);
  }

  .sl-iconbtn.primary{
    border-color: rgb(8, 91, 245);
    background: rgb(8, 91, 245);
    color:#fff;
    box-shadow: 0 8px 14px rgba(37,99,235,0.18);
  }

  .sl-iconbtn.danger{
    border-color:#ef4444;
    background:#ef4444;
    color:#fff;
  }

  .sl-spacer{
    flex: 1 1 auto;
    min-width: 10px;
  }

  /* table */
  .sl-table-wrap{
    width:100%; overflow:auto; border:1px solid #e5e7eb; border-radius:14px; background:#fff;
  }
  .sl-table{ width:100%; border-collapse:collapse; table-layout:auto; min-width:1100px; }
  .sl-table thead th{
    background:#f4f7f6; color:#0f172a; font-weight:800; text-transform:uppercase; font-size:12px; letter-spacing:.03em;
    border-bottom:1px solid #e5e7eb; padding:6px 8px; position:sticky; top:0; z-index:1; text-align:center; white-space:nowrap;
  }
  .sl-table tbody td{
    padding:6px 8px; border-bottom:1px solid #f1f5f9; vertical-align:middle; color:#0f172a; font-size:14px; text-align:center;
  }
  .sl-table tbody tr:hover{ background:#f9fbff; }
  .sl-click{ cursor:pointer; }

  .sl-pill{
    display:inline-flex; align-items:center; gap:6px; padding:5px 10px; border-radius:999px;
    border:1px solid #e5e7eb; font-weight:900; font-size:12px; text-transform:uppercase;
  }
  .sl-pill-blue{ background:#e0edff; color:#0b3aa3; border-color:#b9d4ff; }
  .sl-pill-green{ background:#eafff1; color:#065f46; border-color:#b7f7d0; }
  .sl-pill-red{ background:#ffe7e7; color:#991b1b; border-color:#ffc0c0; }
  .sl-pill-amber{ background:#fff7d6; color:#92400e; border-color:#fde68a; }
  .sl-pill-purple{ background:#f3e8ff; color:#6b21a8; border-color:#d8b4fe; }
  .sl-pill-gray{ background:#f3f4f6; color:#374151; border-color:#d1d5db; }

  .sl-request-switch{
    display:flex;
    gap:8px;
    align-items:center;
    flex-wrap:wrap;
    margin-bottom:10px;
  }

  .sl-request-tab{
    border:1px solid #dbe3ea;
    border-radius:10px;
    background:#fff;
    color:#0f172a;
    font-weight:900;
    padding:8px 12px;
    cursor:pointer;
  }

  .sl-request-tab.active{
    background:#0b5bf5;
    border-color:#0b5bf5;
    color:#fff;
  }

  .sl-request-card{
    border:1px solid #e5e7eb;
    border-radius:14px;
    background:#fff;
    padding:10px;
  }

  .sl-request-actions{
    display:flex;
    justify-content:center;
    gap:6px;
    flex-wrap:wrap;
  }

  .sl-mini-btn{
    border:0;
    border-radius:9px;
    padding:7px 10px;
    font-size:12px;
    font-weight:900;
    cursor:pointer;
    display:inline-flex;
    align-items:center;
    gap:5px;
  }

  .sl-mini-view{ background:#e0edff; color:#0b3aa3; }
  .sl-mini-approve{ background:#dcfce7; color:#166534; }
  .sl-mini-reject{ background:#fee2e2; color:#991b1b; }

  .sl-detail-grid{
    display:grid;
    grid-template-columns:repeat(2,minmax(0,1fr));
    gap:10px;
  }

  .sl-detail-item{
    border:1px solid #e5e7eb;
    border-radius:10px;
    padding:9px 10px;
    background:#f8fafc;
  }

  .sl-detail-label{
    font-size:10px;
    text-transform:uppercase;
    font-weight:900;
    letter-spacing:.04em;
    color:#64748b;
    margin-bottom:3px;
  }

  .sl-detail-value{
    color:#0f172a;
    font-size:13px;
    font-weight:800;
    word-break:break-word;
    white-space:pre-wrap;
  }

  .sl-detail-section{
    margin-top:14px;
    border:1px solid #dbe3ea;
    border-radius:14px;
    padding:12px;
    background:#fff;
  }

  .sl-detail-section:first-child{ margin-top:0; }

  .sl-detail-section-title{
    font-size:13px;
    font-weight:950;
    text-transform:uppercase;
    letter-spacing:.04em;
    color:#0b5bf5;
    margin-bottom:10px;
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:10px;
  }

  .sl-detail-section-note{
    font-size:11px;
    color:#64748b;
    text-transform:none;
    letter-spacing:0;
    font-weight:800;
  }

  .sl-detail-grid-three{
    display:grid;
    grid-template-columns:repeat(3,minmax(0,1fr));
    gap:10px;
  }

  .sl-detail-full{ grid-column:1 / -1; }

  .sl-photo-grid{
    display:flex;
    gap:10px;
    flex-wrap:wrap;
  }

  .sl-photo-card{
    width:150px;
    border:1px solid #e5e7eb;
    border-radius:12px;
    padding:7px;
    background:#f8fafc;
  }

  .sl-photo-card img{
    width:100%;
    height:110px;
    object-fit:cover;
    border-radius:8px;
    border:1px solid #e5e7eb;
    background:#fff;
  }

  .sl-photo-name{
    margin-top:6px;
    font-size:10px;
    font-weight:800;
    color:#475569;
    word-break:break-all;
  }

  .sl-sensitive{
    color:#92400e;
    font-size:11px;
    font-weight:900;
  }

  @media(max-width:1000px){
    .sl-detail-grid-three{ grid-template-columns:repeat(2,minmax(0,1fr)); }
  }

  @media(max-width:768px){
    .sl-detail-grid, .sl-detail-grid-three{ grid-template-columns:1fr; }
  }

  .sl-modal-actions{
    display:flex; flex-wrap:wrap; gap:10px; justify-content:center; margin-top:10px;
  }
  .sl-btn{
    border:none; border-radius:12px; padding:10px 14px; font-weight:900; text-transform:uppercase; font-size:12px;
    display:inline-flex; align-items:center; justify-content:center; gap:8px; cursor:pointer;
  }
  .sl-btn-follow{ background:#0b5bf5; color:#fff; }
  .sl-btn-convert{ background:#10b981; color:#fff; }
  .sl-btn-reject{ background:#ef4444; color:#fff; }
  .sl-btn-delete{ background:#111827; color:#fff; }

  .sl-remarks-wrap{
    margin-top:14px;
    border:1px solid #e5e7eb;
    border-radius:14px;
    padding:12px;
    background:#ffffff;
  }
  .sl-remarks-head{
    display:flex;
    align-items:center;
    justify-content:space-between;
    gap:10px;
    margin-bottom:10px;
  }
  .sl-remarks-list{
    max-height:220px;
    overflow:auto;
    border-top:1px solid #f1f5f9;
    padding-top:10px;
  }
  .sl-remark-item{
    display:flex;
    gap:10px;
    padding:10px;
    border:1px solid #f1f5f9;
    border-radius:12px;
    margin-bottom:8px;
    background:#f9fafb;
    text-align:left;
  }
  .sl-remark-ts{
    min-width:170px;
    font-weight:900;
    color:#0f172a;
    font-size:12px;
    white-space:nowrap;
  }
  .sl-remark-text{
    flex:1;
    color:#111827;
    font-size:13px;
    font-weight:700;
    word-break:break-word;
  }
`;

const injectOnce = () => {
  if (document.getElementById("saleslead-inline-css")) return;
  const style = document.createElement("style");
  style.id = "saleslead-inline-css";
  style.innerHTML = CSS_PAGE;
  document.head.appendChild(style);
};

/* =========================
   helpers
========================= */
const toStr = (v) => (v === null || v === undefined ? "" : String(v));

const istDateTime = (dLike) => {
  if (!dLike) return { date: "", time: "" };
  const d = new Date(dLike);
  if (Number.isNaN(d.getTime())) return { date: "", time: "" };

  const formatter = new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const out = formatter.format(d); // "dd/mm/yyyy, hh:mm:ss"
  const parts = out.split(", ");
  const datePart = parts[0] || "";
  const timePart = parts[1] || "";
  const [dd, mm, yyyy] = datePart.split("/");
  const date = dd && mm && yyyy ? `${yyyy}-${mm}-${dd}` : "";
  return { date, time: timePart };
};

const lastRemarkObj = (r) => {
  const arr = Array.isArray(r?.remark) ? r.remark : [];
  if (!arr.length) return null;
  return arr[arr.length - 1] || null;
};

const hasRemark = (r) => {
  const lr = lastRemarkObj(r);
  const v = lr?.remark ?? "";
  return String(v || "").trim().length > 0;
};

const leadType = (r) =>
  String(r?.leadStatus || r?.type || "")
    .trim()
    .toLowerCase();

const conversionStatus = (r) => String(r?.conversionStatus || "").trim();

const getBucket = (r) => {
  const conversion = conversionStatus(r).toLowerCase();
  const t = leadType(r);

  // Approved and conversion-rejected records stay in conversion history.
  // They are still the SAME MongoDB Customer document.
  if (conversion === "approved" || conversion === "rejected") {
    return "converted";
  }

  if (t === "converted") return "converted";
  if (t === "rejected") return "rejected";
  if (hasRemark(r)) return "followup";
  return "leads";
};

const requestBadgeClass = (value) => {
  const v = String(value || "")
    .trim()
    .toLowerCase();
  if (v === "approved") return "sl-pill sl-pill-green";
  if (v === "rejected") return "sl-pill sl-pill-red";
  if (v === "waiting") return "sl-pill sl-pill-purple";
  if (v === "pending verification") return "sl-pill sl-pill-amber";
  if (v === "pending") return "sl-pill sl-pill-amber";
  return "sl-pill sl-pill-gray";
};

const formatDateTime = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return toStr(value);
  return new Intl.DateTimeFormat("en-IN", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(d);
};

const lastActivityDateTime = (r) => {
  const lr = lastRemarkObj(r);
  if (lr?.date && lr?.time) return { date: lr.date, time: lr.time };
  return istDateTime(r?.createdAt);
};

const CUSTOMER_MEDIA_BASE = "https://customer-node.rupioo.com";

const registrationTypeText = (value) => {
  const v = toStr(value).trim();
  if (v === "0") return "Regular (0)";
  if (v === "1") return "Registered (1)";
  if (v === "2") return "Unregistered (2)";
  return v;
};

const partyTypeText = (value) => {
  const v = toStr(value).trim();
  if (v === "0") return "Creditor (0)";
  if (v === "1") return "Debitor (1)";
  return v;
};

const transporterTypeText = (value) => {
  const v = toStr(value).trim();
  if (v === "1") return "Local (1)";
  if (v === "2") return "Other (2)";
  return v;
};

const displayOrDash = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
};

const displayArrayOrObject = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) {
    if (!value.length) return "—";
    return value
      .map((item, index) => {
        if (item === null || item === undefined) return "";
        if (typeof item !== "object") return String(item);
        return (
          item?.companyName ||
          item?.CompanyName ||
          item?.firstName ||
          item?.name ||
          item?.groupName ||
          item?.categoryName ||
          item?._id ||
          `Item ${index + 1}: ${JSON.stringify(item)}`
        );
      })
      .filter(Boolean)
      .join("\n");
  }
  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

const mediaUrl = (value) => {
  if (!value) return "";
  const raw =
    typeof value === "object"
      ? value?.uri || value?.url || value?.name || ""
      : String(value);
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;
  return `${CUSTOMER_MEDIA_BASE}/Images/${raw}`;
};

const mediaName = (value, fallback) => {
  if (!value) return fallback;
  if (typeof value === "object")
    return value?.name || value?.fileName || value?.uri || fallback;
  return String(value);
};

function DetailItem({ label, value, full = false, sensitive = false }) {
  return (
    <div className={`sl-detail-item ${full ? "sl-detail-full" : ""}`}>
      <div className="sl-detail-label">{label}</div>
      <div className={`sl-detail-value ${sensitive ? "sl-sensitive" : ""}`}>
        {displayOrDash(value)}
      </div>
    </div>
  );
}

function PhotoDetails({ personalPhoto, shopPhotos }) {
  const images = [];
  if (personalPhoto) {
    images.push({ type: "Personal Photo", value: personalPhoto });
  }
  (Array.isArray(shopPhotos) ? shopPhotos : []).forEach((value, index) => {
    images.push({ type: `Shop Photo ${index + 1}`, value });
  });

  if (!images.length) {
    return (
      <DetailItem label="Uploaded Photos" value="No photos uploaded" full />
    );
  }

  return (
    <div className="sl-detail-item sl-detail-full">
      <div className="sl-detail-label">Uploaded Photos</div>
      <div className="sl-photo-grid">
        {images.map((image, index) => {
          const url = mediaUrl(image.value);
          const name = mediaName(image.value, image.type);
          return (
            <div className="sl-photo-card" key={`${image.type}-${index}`}>
              {url ? (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  title="Open full image"
                >
                  <img
                    src={url}
                    alt={image.type}
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                    }}
                  />
                </a>
              ) : null}
              <div className="sl-photo-name">
                {image.type}: {name}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function BankDetailsValue({ value }) {
  const rows = Array.isArray(value) ? value : [];
  if (!rows.length) return <DetailItem label="Bank Details" value="—" full />;

  return (
    <div className="sl-detail-item sl-detail-full">
      <div className="sl-detail-label">Bank Details</div>
      <div className="sl-detail-value">
        {rows.map((bank, index) => (
          <div
            key={index}
            style={{ marginBottom: index === rows.length - 1 ? 0 : 8 }}
          >
            <b>Bank {index + 1}:</b>{" "}
            {[bank?.Account_Name, bank?.Account_No, bank?.Ifsc_code]
              .filter(Boolean)
              .join(" • ") || "—"}
          </div>
        ))}
      </div>
    </div>
  );
}

function ConversionFullDetails({ row }) {
  if (!row) return null;

  const salesperson =
    typeof row?.created_by === "object"
      ? [row?.created_by?.firstName, row?.created_by?.lastName]
          .filter(Boolean)
          .join(" ") ||
        row?.created_by?.email ||
        row?.created_by?._id ||
        "Sales Person"
      : row?.created_by || "Sales Person";

  const assignedTransporters = displayArrayOrObject(row?.assignTransporter);
  const passwordState = toStr(row?.password).trim()
    ? "Set (hidden for security)"
    : "Not set";

  return (
    <>
      <div className="sl-detail-section">
        <div className="sl-detail-section-title">
          Company Information
          <span className="sl-detail-section-note">
            Exactly as saved during conversion
          </span>
        </div>
        <div className="sl-detail-grid-three">
          <DetailItem
            label="Registration Type"
            value={registrationTypeText(row?.registrationType)}
          />
          <DetailItem
            label="Party Type"
            value={partyTypeText(row?.partyType)}
          />
          <DetailItem label="GST Number" value={row?.gstNumber} />
          <DetailItem label="Company Name" value={row?.CompanyName} />
          <DetailItem label="Email" value={row?.email} />
          <DetailItem label="Company Contact" value={row?.contactNumber} />
          <DetailItem label="Address Line 1" value={row?.address1} full />
          <DetailItem label="Address Line 2" value={row?.address2} full />
          <DetailItem
            label="Company Address (legacy)"
            value={row?.CompanyAddress}
            full
          />
          <DetailItem label="Shop Size" value={row?.shopSize} />
          <DetailItem label="Pincode" value={row?.pincode} />
          <DetailItem label="District" value={row?.District} />
          <DetailItem label="City" value={row?.City} />
          <DetailItem label="State" value={row?.State} />
          <DetailItem label="Company PAN" value={row?.comPanNo} />
          <DetailItem
            label="Deals In Products"
            value={row?.dealsInProducts}
            full
          />
          <DetailItem label="Annual Turnover" value={row?.annualTurnover} />
        </div>
      </div>

      <div className="sl-detail-section">
        <div className="sl-detail-section-title">
          Personal / KYC Information
        </div>
        <div className="sl-detail-grid-three">
          <DetailItem label="First Name" value={row?.firstName} />
          <DetailItem label="Last Name" value={row?.lastName} />
          <DetailItem label="Owner Name" value={row?.ownerName} />
          <DetailItem label="Personal Contact" value={row?.mobileNumber} />
          <DetailItem label="Passport Number" value={row?.passPortNo} />
          <DetailItem label="PAN Number" value={row?.panNo} />
          <DetailItem label="Aadhaar Number" value={row?.aadharNo} />
          <DetailItem label="Personal Pincode" value={row?.personalPincode} />
          <DetailItem label="Personal City" value={row?.Pcity} />
          <DetailItem label="Personal State" value={row?.Pstate} />
          <DetailItem
            label="Owner Address"
            value={row?.address || row?.ownerAddress}
            full
          />
        </div>
      </div>

      <div className="sl-detail-section">
        <div className="sl-detail-section-title">
          Customer / Commercial Settings
        </div>
        <div className="sl-detail-grid-three">
          <DetailItem
            label="Transporter Type"
            value={transporterTypeText(row?.transporterDetail)}
          />
          <DetailItem
            label="Assigned Transporter(s)"
            value={assignedTransporters}
            full
          />
          <DetailItem
            label="Customer Category"
            value={displayArrayOrObject(row?.category)}
          />
          <DetailItem label="Password" value={passwordState} sensitive />
          <DetailItem label="Lock In Time" value={row?.lockInTime} />
          <DetailItem label="Credit Limit" value={row?.limit} />
          <DetailItem label="Remaining Limit" value={row?.remainingLimit} />
          <DetailItem label="Due Days" value={row?.duedate} />
          <DetailItem label="Service Area" value={row?.serviceArea} />
          <DetailItem label="Payment Term" value={row?.paymentTerm} />
          <DetailItem label="Geotagging" value={row?.geotagging} full />
          <DetailItem label="Opening Balance" value={row?.OpeningBalance} />
          <DetailItem label="Balance Type" value={row?.Type} />
          <DetailItem
            label="Opening Financial Year"
            value={row?.openingFinancialYear}
          />
          <DetailItem label="Latitude" value={row?.latitude} />
          <DetailItem label="Longitude" value={row?.longitude} />
          <DetailItem
            label="Current Address"
            value={row?.currentAddress}
            full
          />
          <BankDetailsValue value={row?.bankDetails} />
        </div>
      </div>

      <div className="sl-detail-section">
        <div className="sl-detail-section-title">
          Uploaded Documents / Photos
        </div>
        <div className="sl-detail-grid-three">
          <PhotoDetails
            personalPhoto={row?.Photo}
            shopPhotos={row?.shopPhoto}
          />
        </div>
      </div>

      <div className="sl-detail-section">
        <div className="sl-detail-section-title">
          Verification & Conversion Audit
        </div>
        <div className="sl-detail-grid-three">
          <DetailItem label="Lead Mongo ID" value={row?._id} />
          <DetailItem label="Customer ID / Code" value={row?.id} />
          <DetailItem label="Sales Person" value={salesperson} />
          <DetailItem label="Database" value={row?.database} />
          <DetailItem label="Record Status" value={row?.status} />
          <DetailItem label="Lead Status" value={row?.leadStatus} />
          <DetailItem label="Lead Status Check" value={row?.leadStatusCheck} />
          <DetailItem
            label="Conversion Status"
            value={row?.conversionStatus || "Not Started"}
          />
          <DetailItem
            label="OTP Mobile"
            value={row?.conversionOtpMobile || row?.mobileNumber}
          />
          <DetailItem
            label="OTP Verification"
            value={
              row?.conversionOtpVerifiedAt
                ? `Verified • ${formatDateTime(row?.conversionOtpVerifiedAt)}`
                : "Pending Verification"
            }
          />
          <DetailItem
            label="OTP Last Sent"
            value={formatDateTime(row?.conversionOtpLastSentAt)}
          />
          <DetailItem
            label="OTP Send Count"
            value={row?.conversionOtpSendCount}
          />
          <DetailItem
            label="OTP Failed Attempts"
            value={row?.conversionOtpFailedAttempts}
          />
          <DetailItem
            label="Draft Updated At"
            value={formatDateTime(row?.conversionDraftUpdatedAt)}
          />
          <DetailItem
            label="Sent For Approval At"
            value={formatDateTime(row?.conversionRequestedAt)}
          />
          <DetailItem
            label="Reviewed At"
            value={formatDateTime(row?.conversionReviewedAt)}
          />
          <DetailItem label="Reviewed By" value={row?.conversionReviewedBy} />
          <DetailItem
            label="Converted At"
            value={formatDateTime(row?.convertedAt)}
          />
          <DetailItem
            label="Created At"
            value={formatDateTime(row?.createdAt)}
          />
          <DetailItem
            label="Last Updated At"
            value={formatDateTime(row?.updatedAt)}
          />
          <DetailItem
            label="SuperAdmin Review Remark"
            value={row?.conversionReviewRemark}
            full
          />
        </div>
      </div>
    </>
  );
}

// ✅ FIXED EXPORT COLUMNS (XLSX only uses this; PDF uses visible cols)
const EXPORT_HEADERS = [
  "CompanyName",
  "mobileNumber",
  "address",
  "pincode",
  "City",
  "State",
];

const buildFixedExportRows = (dataRows) => {
  return (dataRows || []).map((r) => ({
    CompanyName: toStr(r?.CompanyName),
    mobileNumber: toStr(r?.mobileNumber),
    address: toStr(r?.address),
    pincode: toStr(r?.pincode),
    City: toStr(r?.City),
    State: toStr(r?.State),
  }));
};

const BASE_COLS = [
  { key: "__check__", header: "", get: () => "" },
  { key: "date", header: "DATE", get: (r) => lastActivityDateTime(r).date },
  { key: "time", header: "TIME", get: (r) => lastActivityDateTime(r).time },
  { key: "status", header: "STATUS", get: (r) => r?.status || "" },
  {
    key: "conversionStatus",
    header: "CONVERSION",
    get: (r) => r?.conversionStatus || "",
  },
  {
    key: "leadStatus",
    header: "LEAD TYPE",
    get: (r) => (leadType(r) ? leadType(r) : "lead"),
  },
  { key: "CompanyName", header: "COMPANY", get: (r) => r?.CompanyName || "" },
  { key: "mobileNumber", header: "MOBILE", get: (r) => r?.mobileNumber || "" },
  { key: "address", header: "ADDRESS", get: (r) => r?.address || "" },
  { key: "pincode", header: "PINCODE", get: (r) => r?.pincode || "" },
  { key: "City", header: "CITY", get: (r) => r?.City || "" },
  { key: "State", header: "STATE", get: (r) => r?.State || "" },
  {
    key: "salesPerson",
    header: "SALES PERSON",
    get: (r) => r?.created_by?.firstName || "Not Assigned",
  },
  {
    key: "remark",
    header: "REMARK",
    get: (r) => {
      const lr = lastRemarkObj(r);
      if (!lr) return "";
      const d = toStr(lr?.date);
      const t = toStr(lr?.time);
      const txt = toStr(lr?.remark);
      const ts = [d, t].filter(Boolean).join(" ");
      return ts ? `${ts} - ${txt}` : txt;
    },
  },
];

const DEFAULT_COL_KEYS = [
  "__check__",
  "date",
  "time",
  "leadStatus",
  "status",
  "conversionStatus",
  "CompanyName",
  "mobileNumber",
  "address",
  "pincode",
  "City",
  "State",
  "salesPerson",
  "remark",
];

/* =========================
   Tab Body Component
========================= */
function LeadsTab({
  rows,
  visibleCols,
  selectedIds,
  toggleSelected,
  openEdit,
}) {
  const noData = !rows?.length;
  const selectedIdSet = useMemo(
    () => new Set(selectedIds || []),
    [selectedIds],
  );

  return (
    <Card style={{ padding: 8, borderRadius: 14, border: "1px solid #e5e7eb" }}>
      {noData ? (
        <div style={{ padding: 24, textAlign: "center", color: "#6b7280" }}>
          No leads found.
        </div>
      ) : (
        <div className="sl-table-wrap">
          <table className="sl-table">
            <thead>
              <tr>
                {visibleCols.map((c) => (
                  <th key={c.key}>{c.header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r?._id}>
                  {visibleCols.map((c) => {
                    if (c.key === "__check__") {
                      return (
                        <td key={c.key}>
                          <Input
                            type="checkbox"
                            checked={selectedIdSet.has(r._id)}
                            onChange={(e) =>
                              toggleSelected(r._id, e.target.checked)
                            }
                            onClick={(e) => e.stopPropagation()}
                          />
                        </td>
                      );
                    }

                    return (
                      <td
                        key={c.key}
                        className="sl-click"
                        onClick={() => openEdit(r)}
                        title="Click to open lead"
                      >
                        {toStr(c.get(r))}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}

/* =========================
   SuperAdmin Requested Tab
========================= */
function RequestedTab({
  requestTypeTab,
  setRequestTypeTab,
  leadCreationRequests,
  conversionRequests,
  search,
  openRequestReview,
  openConversionEdit,
}) {
  const term = String(search || "")
    .trim()
    .toLowerCase();

  const matches = (row, fields) => {
    if (!term) return true;
    return fields.some((field) =>
      toStr(row?.[field]).toLowerCase().includes(term),
    );
  };

  const creationRows = (leadCreationRequests || []).filter((row) =>
    matches(row, [
      "CompanyName",
      "mobileNumber",
      "pincode",
      "City",
      "State",
      "requestedByName",
      "status",
      "reviewRemark",
    ]),
  );

  const conversionRows = (conversionRequests || []).filter((row) => {
    const salesperson =
      typeof row?.created_by === "object"
        ? `${row?.created_by?.firstName || ""} ${row?.created_by?.lastName || ""}`
        : row?.created_by || "";

    const haystack = [
      row?.CompanyName,
      row?.mobileNumber,
      row?.pincode,
      row?.City,
      row?.State,
      row?.email,
      row?.registrationType,
      row?.gstNumber,
      row?.conversionStatus,
      row?.conversionReviewRemark,
      salesperson,
    ]
      .map((v) => toStr(v).toLowerCase())
      .join(" ");

    return !term || haystack.includes(term);
  });

  const pendingCreation = (leadCreationRequests || []).filter(
    (r) => String(r?.status || "").toLowerCase() === "pending",
  ).length;

  const waitingConversion = (conversionRequests || []).filter(
    (r) => String(r?.conversionStatus || "").toLowerCase() === "waiting",
  ).length;

  return (
    <Card
      style={{ padding: 10, borderRadius: 14, border: "1px solid #e5e7eb" }}
    >
      <div className="sl-request-switch">
        <button
          type="button"
          className={`sl-request-tab ${
            requestTypeTab === "leadCreation" ? "active" : ""
          }`}
          onClick={() => setRequestTypeTab("leadCreation")}
        >
          Lead Creation Requests ({leadCreationRequests.length})
          {pendingCreation > 0 ? ` • ${pendingCreation} Pending` : ""}
        </button>

        <button
          type="button"
          className={`sl-request-tab ${
            requestTypeTab === "conversion" ? "active" : ""
          }`}
          onClick={() => setRequestTypeTab("conversion")}
        >
          Conversion Requests ({conversionRequests.length})
          {waitingConversion > 0 ? ` • ${waitingConversion} Waiting` : ""}
        </button>
      </div>

      {requestTypeTab === "leadCreation" ? (
        creationRows.length === 0 ? (
          <div style={{ padding: 24, textAlign: "center", color: "#6b7280" }}>
            No lead creation requests found.
          </div>
        ) : (
          <div className="sl-table-wrap">
            <table className="sl-table" style={{ minWidth: 1150 }}>
              <thead>
                <tr>
                  <th>Requested</th>
                  <th>Company</th>
                  <th>Mobile</th>
                  <th>Pincode</th>
                  <th>City / State</th>
                  <th>Sales Person</th>
                  <th>Status</th>
                  <th>Review Remark</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {creationRows.map((row) => {
                  const isPending =
                    String(row?.status || "").toLowerCase() === "pending";

                  return (
                    <tr key={row?._id}>
                      <td>{formatDateTime(row?.createdAt)}</td>
                      <td>{toStr(row?.CompanyName)}</td>
                      <td>{toStr(row?.mobileNumber)}</td>
                      <td>{toStr(row?.pincode)}</td>
                      <td>
                        {[row?.City, row?.State].filter(Boolean).join(", ")}
                      </td>
                      <td>{toStr(row?.requestedByName) || "Sales Person"}</td>
                      <td>
                        <span className={requestBadgeClass(row?.status)}>
                          {row?.status || "Pending"}
                        </span>
                      </td>
                      <td>{toStr(row?.reviewRemark)}</td>
                      <td>
                        <div className="sl-request-actions">
                          <button
                            type="button"
                            className="sl-mini-btn sl-mini-view"
                            onClick={() =>
                              openRequestReview("leadCreation", row)
                            }
                          >
                            <FaEye size={12} /> View
                          </button>

                          {isPending && (
                            <>
                              <button
                                type="button"
                                className="sl-mini-btn sl-mini-approve"
                                onClick={() =>
                                  openRequestReview(
                                    "leadCreation",
                                    row,
                                    "Approved",
                                  )
                                }
                              >
                                <FaCheck size={12} /> Approve
                              </button>
                              <button
                                type="button"
                                className="sl-mini-btn sl-mini-reject"
                                onClick={() =>
                                  openRequestReview(
                                    "leadCreation",
                                    row,
                                    "Rejected",
                                  )
                                }
                              >
                                <FaTimes size={12} /> Reject
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )
      ) : conversionRows.length === 0 ? (
        <div style={{ padding: 24, textAlign: "center", color: "#6b7280" }}>
          No conversion requests found.
        </div>
      ) : (
        <div className="sl-table-wrap">
          <table className="sl-table" style={{ minWidth: 1250 }}>
            <thead>
              <tr>
                <th>Requested</th>
                <th>Company</th>
                <th>Mobile</th>
                <th>Registration</th>
                <th>GST</th>
                <th>Sales Person</th>
                <th>OTP</th>
                <th>Conversion Status</th>
                <th>Review Remark</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {conversionRows.map((row) => {
                const status = String(row?.conversionStatus || "").trim();
                const canReview = status.toLowerCase() === "waiting";
                const salesperson =
                  typeof row?.created_by === "object"
                    ? `${row?.created_by?.firstName || ""} ${
                        row?.created_by?.lastName || ""
                      }`.trim()
                    : "";

                return (
                  <tr key={row?._id}>
                    <td>
                      {formatDateTime(
                        row?.conversionRequestedAt ||
                          row?.conversionDraftUpdatedAt,
                      )}
                    </td>
                    <td>{toStr(row?.CompanyName)}</td>
                    <td>{toStr(row?.mobileNumber)}</td>
                    <td>{toStr(row?.registrationType)}</td>
                    <td>{toStr(row?.gstNumber)}</td>
                    <td>{salesperson || "Sales Person"}</td>
                    <td>
                      {row?.conversionOtpVerifiedAt ? (
                        <span className="sl-pill sl-pill-green">Verified</span>
                      ) : (
                        <span className="sl-pill sl-pill-amber">
                          Pending Verification
                        </span>
                      )}
                    </td>
                    <td>
                      <span className={requestBadgeClass(status)}>
                        {status || "Not Started"}
                      </span>
                    </td>
                    <td>{toStr(row?.conversionReviewRemark)}</td>
                    <td>
                      <div className="sl-request-actions">
                        <button
                          type="button"
                          className="sl-mini-btn sl-mini-view"
                          onClick={() => openRequestReview("conversion", row)}
                        >
                          <FaEye size={12} /> View
                        </button>

                        {canReview && (
                          <button
                            type="button"
                            className="sl-mini-btn sl-mini-view"
                            onClick={() => openConversionEdit(row)}
                            title="Edit customer details before approval"
                          >
                            <FaEdit size={12} /> Edit
                          </button>
                        )}

                        {canReview && (
                          <>
                            <button
                              type="button"
                              className="sl-mini-btn sl-mini-approve"
                              onClick={() =>
                                openRequestReview("conversion", row, "Approved")
                              }
                            >
                              <FaCheck size={12} /> Approve
                            </button>
                            <button
                              type="button"
                              className="sl-mini-btn sl-mini-reject"
                              onClick={() =>
                                openRequestReview("conversion", row, "Rejected")
                              }
                            >
                              <FaTimes size={12} /> Reject
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}

/* =========================
   Main Page
========================= */
export default function SalesLead() {
  const navigate = useNavigate();
  useEffect(() => injectOnce(), []);

  // ------------- state -------------
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");

  const [colsModal, setColsModal] = useState(false);
  const [uploadModal, setUploadModal] = useState(false);

  const [permissions, setPermissions] = useState({
    View: true,
    Create: true,
    Edit: true,
    Delete: true,
    Download: true,
    BulkUpload: true,
  });

  const [rows, setRows] = useState([]);
  const [allRows, setAllRows] = useState([]);

  // SuperAdmin request queues
  const [leadCreationRequests, setLeadCreationRequests] = useState([]);
  const [conversionRequests, setConversionRequests] = useState([]);
  const [requestTypeTab, setRequestTypeTab] = useState("leadCreation");
  const [requestReviewModal, setRequestReviewModal] = useState(false);
  const [requestReviewLoading, setRequestReviewLoading] = useState(false);
  const [requestReview, setRequestReview] = useState({
    kind: "",
    row: null,
    remark: "",
    suggestedDecision: "",
  });

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  const [salesPeople, setSalesPeople] = useState([]);
  const [selectedSalesId, setSelectedSalesId] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  const [isMaster, setIsMaster] = useState(false);

  const [activeTab, setActiveTab] = useState(() => {
    try {
      const returnTab = sessionStorage.getItem("SalesLeadReturnTab");
      if (returnTab) {
        sessionStorage.removeItem("SalesLeadReturnTab");
        return returnTab;
      }
    } catch {}
    return "leads";
  }); // leads | followup | converted | rejected | requested
  const [activeCtx, setActiveCtx] = useState({ uid: null, db: null });

  // column chooser state
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const addBufferRef = useRef([]);

  // upload state
  const [uploadType, setUploadType] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({
    total: 0,
    processed: 0,
    inserted: 0,
    assigned: 0,
    unassigned: 0,
    duplicates: 0,
    invalid: 0,
    batch: 0,
    batches: 0,
  });

  // Auto Assign button state
  const [autoAssigning, setAutoAssigning] = useState(false);

  // Create Lead modal
  const [createLeadModal, setCreateLeadModal] = useState(false);
  const [createLead, setCreateLead] = useState({
    CompanyName: "",
    mobileNumber: "",
    address: "",
    pincode: "",
    City: "",
    State: "",
  });
  const [autoSalesPerson, setAutoSalesPerson] = useState(null);

  // Edit Lead modal
  const [editModal, setEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [editForm, setEditForm] = useState({
    CompanyName: "",
    mobileNumber: "",
    address: "",
    pincode: "",
    City: "",
    State: "",
    created_by: "",
  });

  const [showRemarkBox, setShowRemarkBox] = useState(false);
  const [remarkText, setRemarkText] = useState("");

  // --------------------
  // tiny helpers
  // --------------------
  const getCreatedById = (r) => {
    const cb = r?.created_by;
    if (!cb) return "";
    if (typeof cb === "object") return cb?._id ? String(cb._id) : "";
    return String(cb || "");
  };
  const isAssigned = (r) => Boolean(getCreatedById(r));

  const findSalesPersonByPincode = (pin) => {
    const cleanPin = String(pin || "").trim();
    if (!cleanPin || cleanPin.length < 6) return null;

    const match = (salesPeople || []).find((sp) => {
      const services = sp?.service;
      if (!Array.isArray(services)) return false;
      return services.some(
        (svc) => String(svc?.pincode).trim() === String(cleanPin).trim(),
      );
    });

    return match || null;
  };

  // ============================================================
  // MANUAL AUTO ASSIGN / REASSIGN
  //
  // Re-fetches the latest salesperson service/pincode assignments and
  // latest lead list before making changes. It handles:
  // 1) unassigned lead -> assign to current pincode owner
  // 2) wrongly/stale assigned lead -> reassign to current pincode owner
  // 3) assigned lead whose pincode now has NO owner -> unassign it
  // ============================================================
  const autoAssignAllLeads = async () => {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const uid = activeCtx?.uid || user?._id;
    const db = activeCtx?.db || user?.database;

    if (!uid || !db) {
      return swal("Error", "User/database context not found.", "error");
    }

    if (autoAssigning) return;

    setAutoAssigning(true);

    try {
      // Always fetch CURRENT salesperson pincode ownership when button is clicked.
      const usersRes = await _Get(`${Create_Account_List + uid}/`, db);
      const latestSalesPeople =
        (usersRes?.adminDetails || []).filter(
          (x) => x?.rolename?.roleName === "Sales Person",
        ) || [];

      const mappedSalesPeople = latestSalesPeople.map((p) => ({
        ...p,
        fullName: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
      }));
      setSalesPeople(mappedSalesPeople);

      // Also fetch CURRENT leads so the check is not based on stale page state.
      const resLeads = await _Get(Bulk_Upload_VIEW_LEAD_PARTY, db, uid);
      const latestLeads =
        (resLeads?.LeadParty || []).filter((x) => {
          const conversion = String(x?.conversionStatus || "").toLowerCase();
          return (
            x?.status !== "Deactive" ||
            conversion === "approved" ||
            conversion === "rejected"
          );
        }) || [];

      if (!latestLeads.length) {
        return swal("Auto Assign", "No leads found to check.", "info");
      }

      // Build pincode -> current salesperson owner map.
      // This mirrors the application's normal first-match ownership behavior.
      const pincodeOwner = new Map();
      for (const sp of mappedSalesPeople) {
        const services = Array.isArray(sp?.service) ? sp.service : [];
        for (const service of services) {
          const pin = String(service?.pincode || "").trim();
          if (!pin) continue;
          if (!pincodeOwner.has(pin)) pincodeOwner.set(pin, sp);
        }
      }

      const assignGroups = {}; // { correctSalesPersonId: [leadId...] }
      const unassignGroups = {}; // { oldSalesPersonId: [leadId...] }

      let newlyAssigned = 0;
      let reassigned = 0;
      let staleUnassigned = 0;
      let alreadyCorrect = 0;
      let noPincode = 0;
      let noOwner = 0;

      for (const lead of latestLeads) {
        const leadId = lead?._id;
        if (!leadId) continue;

        const pin = String(lead?.pincode || "").trim();
        const currentId = getCreatedById(lead);

        if (!pin) {
          noPincode += 1;
          continue;
        }

        const correctOwner = pincodeOwner.get(pin) || null;
        const correctId = correctOwner?._id ? String(correctOwner._id) : "";

        if (correctId) {
          if (currentId === correctId) {
            alreadyCorrect += 1;
            continue;
          }

          if (!assignGroups[correctId]) assignGroups[correctId] = [];
          assignGroups[correctId].push(leadId);

          if (currentId) reassigned += 1;
          else newlyAssigned += 1;
          continue;
        }

        // Pincode currently belongs to nobody. If this lead still has an old
        // salesperson, remove that stale assignment.
        noOwner += 1;
        if (currentId) {
          if (!unassignGroups[currentId]) unassignGroups[currentId] = [];
          unassignGroups[currentId].push(leadId);
          staleUnassigned += 1;
        }
      }

      // Apply new / corrected ownership.
      for (const [salesPersonId, leadIds] of Object.entries(assignGroups)) {
        if (!leadIds.length) continue;
        await _PostSave(AssignTo_Sales_Person, {
          leadParty: leadIds.map((id) => ({ id })),
          salesPerson: salesPersonId,
        });
      }

      // Remove stale ownership where the lead pincode no longer belongs to anyone.
      for (const [oldSalesPersonId, leadIds] of Object.entries(
        unassignGroups,
      )) {
        if (!leadIds.length) continue;
        await _PostSave(Customer_UnLink_Unassign, {
          leadParty: leadIds.map((id) => ({ id })),
          salesPerson: oldSalesPersonId,
        });
      }

      await reload(uid, db);

      const changed = newlyAssigned + reassigned + staleUnassigned;
      const lines = [
        `Checked: ${latestLeads.length}`,
        `Newly Assigned: ${newlyAssigned}`,
        `Reassigned to Correct Sales Person: ${reassigned}`,
        `Old Assignment Removed (No Current Pincode Owner): ${staleUnassigned}`,
        `Already Correct: ${alreadyCorrect}`,
      ];

      if (noOwner > 0) lines.push(`Pincodes With No Current Owner: ${noOwner}`);
      if (noPincode > 0) lines.push(`Leads Without Pincode: ${noPincode}`);

      await swal({
        title:
          changed > 0 ? "Auto Assign Completed" : "Assignments Already Correct",
        text: lines.join("\n"),
        icon: noOwner > 0 || noPincode > 0 ? "warning" : "success",
        button: "OK",
      });
    } catch (err) {
      console.error("autoAssignAllLeads error:", err);
      swal(
        "Auto Assign Failed",
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Unable to auto assign leads.",
        "error",
      );
    } finally {
      setAutoAssigning(false);
    }
  };

  // ------------- load -------------
  // Fast list load:
  // 1) salesperson + lead requests run in parallel
  // 2) request queues load in the background and do NOT block the lead table
  // 3) auto-assign does NOT run automatically on page open anymore; use Auto Assign button
  const loadRequestQueues = async (db) => {
    if (!db) return;
    try {
      const [leadRequestResult, conversionRequestResult] =
        await Promise.allSettled([
          _GetByUrlOnly(
            `/customer/lead-creation-requests/${encodeURIComponent(db)}`,
          ),
          _GetByUrlOnly(
            `/customer/lead-conversion-requests/${encodeURIComponent(
              db,
            )}?conversionStatus=all`,
          ),
        ]);

      if (leadRequestResult.status === "fulfilled") {
        setLeadCreationRequests(
          Array.isArray(leadRequestResult.value?.requests)
            ? leadRequestResult.value.requests
            : [],
        );
      }

      if (conversionRequestResult.status === "fulfilled") {
        setConversionRequests(
          Array.isArray(conversionRequestResult.value?.requests)
            ? conversionRequestResult.value.requests
            : [],
        );
      }
    } catch (e) {
      console.error("Unable to load request queues:", e);
    }
  };

  const reload = async (uid, db) => {
    setLoading(true);
    setErrorMsg("");

    try {
      setActiveCtx({ uid, db });

      const inside = CheckPermission("Sales Lead");
      if (inside && typeof inside === "object") {
        setPermissions((prev) => ({ ...prev, ...inside }));
      }

      // These two calls are independent, so do them together.
      const [usersRes, resLeads] = await Promise.all([
        _Get(`${Create_Account_List + uid}/`, db),
        _Get(Bulk_Upload_VIEW_LEAD_PARTY, db, uid),
      ]);

      const onlySales =
        (usersRes?.adminDetails || []).filter(
          (x) => x?.rolename?.roleName === "Sales Person",
        ) || [];

      const mapped = onlySales.map((p) => ({
        ...p,
        fullName: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
      }));
      setSalesPeople(mapped);

      if (
        selectedSalesId &&
        !mapped.some((x) => String(x._id) === String(selectedSalesId))
      ) {
        setSelectedSalesId("");
      }

      const leads =
        (resLeads?.LeadParty || []).filter((x) => {
          const conversion = String(x?.conversionStatus || "").toLowerCase();
          return (
            x?.status !== "Deactive" ||
            conversion === "approved" ||
            conversion === "rejected"
          );
        }) || [];

      const rev = leads.slice().reverse();
      setRows(rev);
      setAllRows(rev);
      setCurrentPage(1);

      // Do not make the user wait for request history before showing leads.
      // Refresh those queues in the background.
      loadRequestQueues(db);
    } catch (e) {
      console.error("[SalesLead] fetch error:", e);
      setErrorMsg(
        e?.response?.data?.message ||
          e?.message ||
          "Unable to load sales leads. Check console for details.",
      );
      setRows([]);
      setAllRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const role = user?.rolename?.roleName;
    setIsMaster(role === "MASTER");
    reload(user?._id, user?.database);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ------------- columns -------------
  const colMap = useMemo(() => {
    const map = new Map();
    BASE_COLS.forEach((c) => map.set(c.key, c));
    return map;
  }, []);

  useEffect(() => {
    const raw = localStorage.getItem("SalesLeadCols");
    let next = [];
    try {
      const parsed = raw ? JSON.parse(raw) : null;
      if (Array.isArray(parsed) && parsed.length)
        next = parsed.filter((k) => colMap.has(k));
    } catch {}
    if (!next.length) next = DEFAULT_COL_KEYS.filter((k) => colMap.has(k));
    setSelectedKeys(next);
  }, [colMap]);

  // Debounce search so a large lead list is not filtered on every keystroke.
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
      setCurrentPage(1);
    }, 180);

    return () => clearTimeout(timer);
  }, [search]);

  const visibleCols = useMemo(() => {
    return selectedKeys.map((k) => colMap.get(k)).filter(Boolean);
  }, [selectedKeys, colMap]);

  // ------------- tabs data -------------
  const tabCounts = useMemo(() => {
    const c = {
      leads: 0,
      followup: 0,
      converted: 0,
      rejected: 0,
      requested: 0,
    };

    rows.forEach((r) => {
      const b = getBucket(r);
      if (c[b] !== undefined) c[b] += 1;
    });

    const pendingLeadRequests = (leadCreationRequests || []).filter(
      (r) => String(r?.status || "").toLowerCase() === "pending",
    ).length;

    const pendingConversions = (conversionRequests || []).filter((r) => {
      const value = String(r?.conversionStatus || "").toLowerCase();
      return value === "pending verification" || value === "waiting";
    }).length;

    c.requested = pendingLeadRequests + pendingConversions;
    return c;
  }, [rows, leadCreationRequests, conversionRequests]);

  const tabRows = useMemo(() => {
    if (activeTab === "requested") return [];
    return rows.filter((r) => getBucket(r) === activeTab);
  }, [rows, activeTab]);

  const filteredRows = useMemo(() => {
    const term = debouncedSearch.trim().toLowerCase();
    if (!term) return tabRows;

    const searchCols = visibleCols.filter((c) => c.key !== "__check__");
    return tabRows.filter((r) =>
      searchCols.some((c) => toStr(c.get(r)).toLowerCase().includes(term)),
    );
  }, [tabRows, debouncedSearch, visibleCols]);

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [currentPage, totalPages]);

  const paginatedRows = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredRows.slice(start, start + pageSize);
  }, [filteredRows, currentPage, pageSize]);

  const showingFrom = filteredRows.length
    ? (currentPage - 1) * pageSize + 1
    : 0;
  const showingTo = Math.min(currentPage * pageSize, filteredRows.length);

  const unassignedCount = useMemo(() => {
    return (rows || []).reduce((acc, r) => acc + (isAssigned(r) ? 0 : 1), 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows]);

  // ------------- selection -------------
  const toggleSelected = (id, checked) => {
    setSelectedIds((prev) =>
      checked ? [...new Set([...prev, id])] : prev.filter((x) => x !== id),
    );
  };

  // ------------- actions -------------
  const deleteOne = (id, after = () => {}) => {
    swal("Warning", "Sure you want to delete it?", {
      buttons: { cancel: "Cancel", catch: { text: "Delete", value: "delete" } },
    }).then(async (value) => {
      if (value === "delete") {
        try {
          await _DeleteByUrl(`/customer/delete-sales-lead`, id);
          setRows((prev) => prev.filter((x) => x._id !== id));
          setAllRows((prev) => prev.filter((x) => x._id !== id));
          setSelectedIds((prev) => prev.filter((x) => x !== id));
          after?.();
        } catch {
          swal("Error", "Unable to delete. Please try again.", "error");
        }
      }
    });
  };

  const deleteBulk = async () => {
    if (!selectedIds.length) {
      return swal(
        "Select Leads",
        "Please select at least one lead to delete.",
        "warning",
      );
    }

    const value = await swal(
      "Delete Selected Leads?",
      `This will delete ${selectedIds.length} selected lead${
        selectedIds.length === 1 ? "" : "s"
      }.`,
      {
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          catch: { text: "Delete Selected", value: "delete" },
        },
        dangerMode: true,
      },
    );

    if (value !== "delete") return;

    setLoading(true);
    try {
      await _DeleteAll("/customer/delete-multiple-sales-lead", {
        salesLead: selectedIds.map((id) => ({ id })),
      });

      setRows((prev) => prev.filter((x) => !selectedIds.includes(x._id)));
      setAllRows((prev) => prev.filter((x) => !selectedIds.includes(x._id)));
      const deletedCount = selectedIds.length;
      setSelectedIds([]);

      swal(
        "Deleted",
        `${deletedCount} selected lead${deletedCount === 1 ? "" : "s"} deleted.`,
        "success",
      );
    } catch (err) {
      console.error("deleteBulk error:", err);
      swal(
        "Error",
        err?.response?.data?.message ||
          "Unable to delete selected leads. Please try again.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const deleteAllLeads = async () => {
    const ids = (allRows || []).map((row) => row?._id).filter(Boolean);

    if (!ids.length) {
      return swal("No Leads", "There are no lead records to delete.", "info");
    }

    const value = await swal(
      "Delete All Leads?",
      `This will delete all ${ids.length} lead record${
        ids.length === 1 ? "" : "s"
      } currently loaded for this database. This action cannot be undone.`,
      {
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          catch: { text: "Delete All", value: "delete-all" },
        },
        dangerMode: true,
      },
    );

    if (value !== "delete-all") return;

    setLoading(true);
    try {
      await _DeleteAll("/customer/delete-multiple-sales-lead", {
        salesLead: ids.map((id) => ({ id })),
      });

      setRows([]);
      setAllRows([]);
      setSelectedIds([]);

      swal(
        "Deleted",
        `All ${ids.length} lead record${ids.length === 1 ? "" : "s"} deleted.`,
        "success",
      );
    } catch (err) {
      console.error("deleteAllLeads error:", err);
      swal(
        "Error",
        err?.response?.data?.message ||
          "Unable to delete all leads. Please try again.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  const assignSelected = async (unlink = false) => {
    if (!selectedIds.length || !selectedSalesId) {
      swal("Please select at least one lead and a Sales Person.");
      return;
    }
    const payload = {
      leadParty: selectedIds.map((id) => ({ id })),
      salesPerson: selectedSalesId,
    };
    setLoading(true);
    try {
      const res = await _PostSave(
        unlink ? Customer_UnLink_Unassign : AssignTo_Sales_Person,
        payload,
      );
      swal("Success", res?.message || "Done", "success");
      await reload(activeCtx.uid, activeCtx.db);
      setSelectedIds([]);
    } catch {
      swal("Error", "Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  const openCreateLead = () => {
    setCreateLead({
      CompanyName: "",
      mobileNumber: "",
      address: "",
      pincode: "",
      City: "",
      State: "",
    });
    setAutoSalesPerson(null);
    setCreateLeadModal(true);
  };

  const submitCreateLead = async (e) => {
    e.preventDefault();

    const company = String(createLead.CompanyName || "").trim();
    const pin = String(createLead.pincode || "").trim();

    if (!company || !pin) return swal("Company and Pincode are required.");

    setLoading(true);
    try {
      const payload = {
        CompanyName: createLead.CompanyName,
        mobileNumber: createLead.mobileNumber,
        address: createLead.address,
        pincode: createLead.pincode,
        City: createLead.City,
        State: createLead.State,
        ...(autoSalesPerson?._id ? { created_by: autoSalesPerson._id } : {}),
      };

      const url = `${Create_Sales_Lead}/${activeCtx.db}`;
      const res = await _PostSave(url, payload);

      swal("Success", res?.message || "Lead created", "success");
      setCreateLeadModal(false);
      await reload(activeCtx.uid, activeCtx.db);
      setActiveTab("leads");
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Unable to create lead.";
      swal("Error", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  const openEdit = async (row) => {
    if (!(permissions?.View || permissions?.Edit || permissions?.Delete))
      return;

    const id = row?._id;
    if (!id) return;

    setEditModal(true);
    setEditLoading(true);
    setShowRemarkBox(false);
    setRemarkText("");
    setEditRow(null);

    try {
      const res = await _GetByUrlOnly(`/customer/sales-lead-by-id/${id}`);
      const data = res?.LeadParty || row;

      setEditRow(data);
      setEditForm({
        CompanyName: data?.CompanyName || "",
        mobileNumber: data?.mobileNumber || "",
        address: data?.address || "",
        pincode: data?.pincode || "",
        City: data?.City || "",
        State: data?.State || "",
        created_by:
          (typeof data?.created_by === "object"
            ? data?.created_by?._id
            : data?.created_by) || "",
      });
    } catch (e) {
      console.error("openEdit fetch error:", e);
      setEditRow(row);
      setEditForm({
        CompanyName: row?.CompanyName || "",
        mobileNumber: row?.mobileNumber || "",
        address: row?.address || "",
        pincode: row?.pincode || "",
        City: row?.City || "",
        State: row?.State || "",
        created_by:
          (typeof row?.created_by === "object"
            ? row?.created_by?._id
            : row?.created_by) || "",
      });
    } finally {
      setEditLoading(false);
    }
  };

  const saveEdit = async () => {
    if (!editRow?._id) return;

    const company = String(editForm.CompanyName || "").trim();
    const pin = String(editForm.pincode || "").trim();

    if (!company || !pin) return swal("Company and Pincode are required.");

    setEditLoading(true);
    try {
      const payload = {
        CompanyName: editForm.CompanyName,
        mobileNumber: editForm.mobileNumber,
        address: editForm.address,
        pincode: editForm.pincode,
        City: editForm.City,
        State: editForm.State,
        ...(editForm.created_by ? { created_by: editForm.created_by } : {}),
      };

      const res = await _Put(
        `/customer/update-sales-lead`,
        editRow._id,
        payload,
      );
      swal("Success", res?.message || "Updated", "success");

      await reload(activeCtx.uid, activeCtx.db);
      setEditRow({ ...(editRow || {}), ...payload });
    } catch {
      swal("Error", "Unable to update. Please try again.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const saveFollowUpRemark = async () => {
    if (!editRow?._id) return;
    const text = String(remarkText || "").trim();
    if (!text) return swal("Please write a remark.");

    const nowIST = istDateTime(new Date());
    const date = nowIST.date;
    const time = nowIST.time;

    setEditLoading(true);
    try {
      const res = await _PostSave(`/customer/save-remark/${editRow._id}`, {
        remark: text,
        date,
        time,
      });
      swal("Success", res?.message || "Remark saved", "success");
      setRemarkText("");
      setShowRemarkBox(false);

      await reload(activeCtx.uid, activeCtx.db);
      setActiveTab("followup");

      try {
        const latestRes = await _GetByUrlOnly(
          `/customer/sales-lead-by-id/${editRow._id}`,
        );
        const latestData = latestRes?.LeadParty || null;
        if (latestData) setEditRow(latestData);
      } catch {}
    } catch {
      swal("Error", "Unable to save remark. Please try again.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const setLeadStatusAndGo = async (status) => {
    if (!editRow?._id) return;
    const clean = String(status || "")
      .trim()
      .toLowerCase();
    if (!clean) return;

    // SuperAdmin cannot bypass the OTP + approval workflow.
    if (clean === "converted") {
      swal(
        "Approval Required",
        "Lead conversion must be initiated by the Sales Person, OTP verified by the lead, and then approved from the Requested tab.",
        "warning",
      );
      return;
    }

    setEditLoading(true);
    try {
      await _Put(`/customer/update-sales-lead`, editRow._id, {
        leadStatus: clean,
      });
      await reload(activeCtx.uid, activeCtx.db);

      if (clean === "rejected") {
        setEditModal(false);
        setActiveTab("rejected");
        swal("Done", "Lead marked as Rejected", "success");
        return;
      }

      setEditModal(false);
    } catch {
      swal("Error", "Unable to update lead status. Please try again.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  // ------------- SuperAdmin request review -------------
  const openRequestReview = (kind, row, suggestedDecision = "") => {
    setRequestReview({
      kind,
      row,
      remark:
        kind === "conversion"
          ? row?.conversionReviewRemark || ""
          : row?.reviewRemark || "",
      suggestedDecision,
    });
    setRequestReviewModal(true);
  };

  const openConversionEdit = (row) => {
    if (!row?._id) return;

    if (
      String(row?.conversionStatus || "")
        .trim()
        .toLowerCase() !== "waiting"
    ) {
      swal(
        "Not Ready",
        "Only OTP-verified conversions with status Waiting can be edited by SuperAdmin before approval.",
        "warning",
      );
      return;
    }

    try {
      sessionStorage.setItem("SalesLeadReturnTab", "requested");
    } catch {}

    setRequestReviewModal(false);

    navigate(`/app/customers/create/${row._id}?conversionEdit=1`, {
      state: {
        conversionEdit: true,
        fromSalesLead: true,
        leadId: row._id,
      },
    });
  };

  const submitRequestDecision = async (decision) => {
    const row = requestReview?.row;
    const kind = requestReview?.kind;
    if (!row?._id || !kind) return;

    const cleanDecision = String(decision || "").trim();
    if (!["Approved", "Rejected"].includes(cleanDecision)) return;

    if (
      kind === "conversion" &&
      String(row?.conversionStatus || "").toLowerCase() !== "waiting"
    ) {
      swal(
        "Not Ready",
        "Only OTP-verified conversions with status Waiting can be reviewed.",
        "warning",
      );
      return;
    }

    if (
      kind === "leadCreation" &&
      String(row?.status || "").toLowerCase() !== "pending"
    ) {
      swal("Already Reviewed", "This request is no longer Pending.", "info");
      return;
    }

    const confirmed = await swal({
      title: `${cleanDecision} request?`,
      text:
        kind === "conversion"
          ? `${row?.CompanyName || "This lead"} will be ${
              cleanDecision === "Approved"
                ? "activated as a customer using the SAME database document"
                : "kept Deactive with conversionStatus Rejected"
            }.`
          : `${row?.CompanyName || "This lead request"} will be ${cleanDecision.toLowerCase()}.`,
      icon: cleanDecision === "Approved" ? "warning" : "warning",
      buttons: ["Cancel", cleanDecision],
      dangerMode: cleanDecision === "Rejected",
    });

    if (!confirmed) return;

    const sessionUser = JSON.parse(localStorage.getItem("userData") || "{}");
    const reviewerId = sessionUser?._id || sessionUser?.id || "";

    setRequestReviewLoading(true);
    try {
      let res;

      if (kind === "leadCreation") {
        res = await _Put(`/customer/lead-creation-request`, row._id, {
          status: cleanDecision,
          reviewedBy: reviewerId,
          reviewRemark: requestReview?.remark || "",
        });
      } else {
        res = await _Put(`/customer/review-lead-conversion`, row._id, {
          conversionStatus: cleanDecision,
          reviewedBy: reviewerId,
          reviewRemark: requestReview?.remark || "",
        });
      }

      swal("Success", res?.message || `Request ${cleanDecision}`, "success");
      setRequestReviewModal(false);
      setRequestReview({
        kind: "",
        row: null,
        remark: "",
        suggestedDecision: "",
      });
      await reload(activeCtx.uid, activeCtx.db);
      setActiveTab("requested");
    } catch (err) {
      swal(
        "Error",
        err?.response?.data?.message ||
          err?.message ||
          "Unable to review this request.",
        "error",
      );
    } finally {
      setRequestReviewLoading(false);
    }
  };

  // ------------- export -------------
  const getExportCols = () => visibleCols.filter((c) => c.key !== "__check__");

  const buildCSVFromRows = (cols, dataRows) => {
    const header = cols.map((c) => c.header).join(",");
    const lines = dataRows.map((r) =>
      cols
        .map((c) => {
          let v = toStr(c.get(r));
          v = v.replace(/"/g, '""');
          return `"${v}"`;
        })
        .join(","),
    );
    return [header, ...lines].join("\r\n");
  };

  const handleExportPDF = async () => {
    const cols = getExportCols();
    const csv = buildCSVFromRows(cols, filteredRows);
    await exportDataToPDF(csv, "SalesLead");
  };

  const handleExportXLSX = (fileName) => {
    const data = buildFixedExportRows(filteredRows);
    const ws = XLSX.utils.json_to_sheet(data, { header: EXPORT_HEADERS });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `${fileName}.xlsx`,
    );
  };

  // ------------- columns modal logic -------------
  const openCols = () => {
    addBufferRef.current = [];
    setSelectedIndex(-1);
    setColsModal(true);
  };

  const handleCheckbox = (checked, colKey) => {
    const buf = addBufferRef.current.slice();
    if (checked) {
      if (!buf.includes(colKey)) buf.push(colKey);
    } else {
      const i = buf.indexOf(colKey);
      if (i >= 0) buf.splice(i, 1);
    }
    addBufferRef.current = buf;
  };

  const addSelectedColumns = () => {
    const next = Array.from(
      new Set([...selectedKeys, ...addBufferRef.current]),
    );
    setSelectedKeys(next);
  };

  const removeAtIndex = () => {
    if (selectedIndex < 0) return;
    const next = selectedKeys.slice();
    next.splice(selectedIndex, 1);
    setSelectedKeys(next);
    setSelectedIndex(-1);
  };

  const shiftUp = () => {
    if (selectedIndex <= 0) return;
    const next = selectedKeys.slice();
    const el = next.splice(selectedIndex, 1)[0];
    next.splice(selectedIndex - 1, 0, el);
    setSelectedKeys(next);
    setSelectedIndex(selectedIndex - 1);
  };

  const shiftDown = () => {
    if (selectedIndex < 0 || selectedIndex >= selectedKeys.length - 1) return;
    const next = selectedKeys.slice();
    const el = next.splice(selectedIndex, 1)[0];
    next.splice(selectedIndex + 1, 0, el);
    setSelectedKeys(next);
    setSelectedIndex(selectedIndex + 1);
  };

  // ------------- upload -------------

  // Split the selected Excel/CSV into smaller XLSX batches.
  // Each batch is actually sent to the backend, so the progress counter
  // represents completed backend processing rather than a fake animation.
  const prepareLeadUploadBatches = async (file, batchSize = 500) => {
    const buffer = await file.arrayBuffer();
    const sourceWorkbook = XLSX.read(buffer, { type: "array" });

    const firstSheetName = sourceWorkbook.SheetNames?.[0];
    if (!firstSheetName) {
      throw new Error("No worksheet found in the selected file.");
    }

    const sourceSheet = sourceWorkbook.Sheets[firstSheetName];
    const matrix = XLSX.utils.sheet_to_json(sourceSheet, {
      header: 1,
      defval: "",
      raw: true,
    });

    if (!Array.isArray(matrix) || matrix.length < 2) {
      throw new Error("The selected file has no lead rows to upload.");
    }

    const headers = matrix[0] || [];
    const dataRows = matrix
      .slice(1)
      .filter((row) =>
        (row || []).some(
          (value) =>
            String(
              value === null || value === undefined ? "" : value,
            ).trim() !== "",
        ),
      );

    if (!dataRows.length) {
      throw new Error("The selected file has no non-empty lead rows.");
    }

    const batches = [];

    for (let i = 0; i < dataRows.length; i += batchSize) {
      const chunkRows = dataRows.slice(i, i + batchSize);
      const ws = XLSX.utils.aoa_to_sheet([headers, ...chunkRows]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Leads");

      const out = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });

      batches.push({
        blob: new Blob([out], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        rowCount: chunkRows.length,
      });
    }

    return {
      totalRows: dataRows.length,
      batches,
    };
  };

  const resetUploadProgress = () => {
    setUploadProgress({
      total: 0,
      processed: 0,
      inserted: 0,
      assigned: 0,
      unassigned: 0,
      duplicates: 0,
      invalid: 0,
      batch: 0,
      batches: 0,
    });
  };

  const submitUpload = async (e) => {
    e.preventDefault();

    if (!uploadType || !uploadFile) {
      return swal(
        "Required",
        "Please choose upload type and Excel/CSV file.",
        "warning",
      );
    }

    const user = JSON.parse(localStorage.getItem("userData") || "{}");
    const database = activeCtx?.db || user?.database || "";

    if (!database) {
      return swal("Error", "Database not found.", "error");
    }

    if (uploading) return;

    setUploading(true);

    try {
      const { totalRows, batches } = await prepareLeadUploadBatches(
        uploadFile,
        500,
      );

      const totals = {
        processed: 0,
        inserted: 0,
        assigned: 0,
        unassigned: 0,
        duplicates: 0,
        invalid: 0,
      };

      setUploadProgress({
        total: totalRows,
        processed: 0,
        inserted: 0,
        assigned: 0,
        unassigned: 0,
        duplicates: 0,
        invalid: 0,
        batch: 0,
        batches: batches.length,
      });

      for (let index = 0; index < batches.length; index++) {
        const batch = batches[index];
        const fd = new FormData();

        fd.append("file", batch.blob, `sales_leads_batch_${index + 1}.xlsx`);
        fd.append("UploadStatus", uploadType);

        const res = await _BulkUpload(
          `${Bulk_Upload_Lead_Customer}/${database}`,
          fd,
        );

        const summary = res?.summary || {};

        totals.processed += batch.rowCount;
        totals.inserted += Number(summary?.inserted || 0);
        totals.assigned += Number(summary?.autoAssigned || 0);
        totals.unassigned += Number(summary?.unassigned || 0);
        totals.duplicates += Number(summary?.duplicates || 0);
        totals.invalid += Number(summary?.invalid || 0);

        // This update occurs only after the backend has finished this batch,
        // therefore the displayed count is an actual processed/inserted count.
        setUploadProgress({
          total: totalRows,
          processed: totals.processed,
          inserted: totals.inserted,
          assigned: totals.assigned,
          unassigned: totals.unassigned,
          duplicates: totals.duplicates,
          invalid: totals.invalid,
          batch: index + 1,
          batches: batches.length,
        });
      }

      setUploadModal(false);
      setUploadFile(null);
      setUploadType("");

      // Refresh with the backend results after all batches finish.
      if (activeCtx?.uid && database) {
        await reload(activeCtx.uid, database);
      }

      setActiveTab("leads");

      const lines = [
        `Excel Rows Processed: ${totals.processed}/${totalRows}`,
        `Leads Inserted: ${totals.inserted}`,
        `Automatically Assigned: ${totals.assigned}`,
      ];

      if (totals.unassigned > 0)
        lines.push(`Unassigned Pincode: ${totals.unassigned}`);
      if (totals.duplicates > 0)
        lines.push(`Duplicates Skipped: ${totals.duplicates}`);
      if (totals.invalid > 0)
        lines.push(`Invalid Rows Skipped: ${totals.invalid}`);

      await swal({
        title: "Bulk Upload Completed",
        text: lines.join("\n"),
        icon:
          totals.unassigned > 0 || totals.invalid > 0 ? "warning" : "success",
        button: "OK",
      });

      resetUploadProgress();
    } catch (err) {
      console.error("Bulk upload error:", err);

      const message =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Something went wrong while uploading.";

      const progressText = uploadProgress.processed
        ? `\nProcessed before failure: ${uploadProgress.processed}/${uploadProgress.total}`
        : "";

      swal("Upload Failed", `${message}${progressText}`, "error");
    } finally {
      setUploading(false);
    }
  };

  /* ✅ IMPORTANT: no hooks below this point */
  const setTab = (t) => {
    setActiveTab(t);
    setSelectedIds([]);
    setCurrentPage(1);
  };

  const editBadge = () => {
    const conversion = conversionStatus(editRow);
    const t = leadType(editRow);

    if (conversion === "Approved")
      return <span className="sl-pill sl-pill-green">Approved Customer</span>;
    if (conversion === "Rejected")
      return <span className="sl-pill sl-pill-red">Conversion Rejected</span>;
    if (conversion === "Waiting")
      return <span className="sl-pill sl-pill-purple">Waiting Approval</span>;
    if (conversion === "Pending Verification")
      return (
        <span className="sl-pill sl-pill-amber">Pending Verification</span>
      );
    if (t === "converted")
      return <span className="sl-pill sl-pill-green">Converted</span>;
    if (t === "rejected")
      return <span className="sl-pill sl-pill-red">Rejected</span>;
    if (hasRemark(editRow))
      return <span className="sl-pill sl-pill-blue">Follow Up</span>;
    return <span className="sl-pill sl-pill-blue">Lead</span>;
  };

  const remarkHistory = Array.isArray(editRow?.remark) ? editRow.remark : [];
  const remarkHistoryNewestFirst = remarkHistory.slice().reverse();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "20rem",
        }}
      >
        <Spinner style={{ height: "4rem", width: "4rem" }} color="primary">
          Loading...
        </Spinner>
      </div>
    );
  }

  return (
    <>
      {errorMsg && (
        <Row>
          <Col sm="12">
            <Alert color="danger" style={{ marginBottom: 10 }}>
              {errorMsg}
            </Alert>
          </Col>
        </Row>
      )}

      {/* ✅ ONE-ROW BAR (NOT sticky now) */}
      <div className="sl-sticky-wrap">
        <Row style={{ marginBottom: 10 }}>
          <Col sm="12">
            <Card className="sl-sticky-card">
              <div className="sl-stickybar">
                {/* Tabs */}
                <div className="sl-tabs">
                  <button
                    type="button"
                    className={`sl-tab ${activeTab === "leads" ? "active" : ""}`}
                    onClick={() => setTab("leads")}
                  >
                    Leads{" "}
                    <span className="sl-count">{tabCounts.leads || 0}</span>
                  </button>
                  <button
                    type="button"
                    className={`sl-tab ${activeTab === "followup" ? "active" : ""}`}
                    onClick={() => setTab("followup")}
                  >
                    Follow Up{" "}
                    <span className="sl-count">{tabCounts.followup || 0}</span>
                  </button>
                  <button
                    type="button"
                    className={`sl-tab ${activeTab === "converted" ? "active" : ""}`}
                    onClick={() => setTab("converted")}
                  >
                    Converted{" "}
                    <span className="sl-count">{tabCounts.converted || 0}</span>
                  </button>
                  <button
                    type="button"
                    className={`sl-tab ${activeTab === "rejected" ? "active" : ""}`}
                    onClick={() => setTab("rejected")}
                  >
                    Rejected{" "}
                    <span className="sl-count">{tabCounts.rejected || 0}</span>
                  </button>
                  <button
                    type="button"
                    className={`sl-tab ${activeTab === "requested" ? "active" : ""}`}
                    onClick={() => setTab("requested")}
                    title="Salesperson requests and customer conversion approvals"
                  >
                    <FaClipboardList size={13} />
                    Requested{" "}
                    <span className="sl-count">{tabCounts.requested || 0}</span>
                  </button>
                </div>

                {/* optional master switch kept in same row */}
                {isMaster && (
                  <div style={{ minWidth: 250 }}>
                    <SuperAdminUI
                      onDropdownChange={(val) =>
                        localStorage.setItem(
                          "SuperadminIdByMaster",
                          JSON.stringify(val),
                        )
                      }
                      onSubmit={(e) => {
                        e.preventDefault();
                        const v = JSON.parse(
                          localStorage.getItem("SuperadminIdByMaster") ||
                            "null",
                        );
                        if (!v) return;
                        const [id, db] = String(v).split(" ");
                        reload(id, db);
                        setSelectedIds([]);
                      }}
                    />
                  </div>
                )}

                <div className="sl-spacer" />

                <div className="sl-field">
                  <Input
                    className="sl-input"
                    placeholder={
                      activeTab === "requested"
                        ? "Search requests..."
                        : "Search lead..."
                    }
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                {/* Sales Person dropdown */}
                <div className="sl-field">
                  <Input
                    type="select"
                    className="sl-select"
                    value={selectedSalesId}
                    onChange={(e) => setSelectedSalesId(e.target.value)}
                  >
                    <option value="">-- Select --</option>
                    {salesPeople.map((sp) => (
                      <option key={sp._id} value={sp._id}>
                        {sp.fullName || sp.firstName || "Sales Person"}
                      </option>
                    ))}
                  </Input>
                </div>

                {/* Create + Upload icons */}
                {permissions?.Create && (
                  <button
                    type="button"
                    className="sl-iconbtn primary"
                    title="Create Lead"
                    onClick={openCreateLead}
                  >
                    <FaPlus size={14} />
                  </button>
                )}

                {permissions?.Create && (
                  <button
                    type="button"
                    className="sl-iconbtn primary"
                    title="Upload"
                    onClick={() => setUploadModal(true)}
                  >
                    <FaUpload size={14} />
                  </button>
                )}

                <button
                  type="button"
                  className="sl-iconbtn"
                  title="Columns"
                  onClick={openCols}
                >
                  <FaSlidersH size={14} />
                </button>

                {permissions?.Download && (
                  <>
                    <button
                      type="button"
                      className="sl-iconbtn"
                      title="Download PDF"
                      onClick={handleExportPDF}
                    >
                      <FaFilePdf size={16} />
                    </button>
                    <button
                      type="button"
                      className="sl-iconbtn"
                      title="Download Excel"
                      onClick={() => handleExportXLSX("SalesLead")}
                    >
                      <FaFileExcel size={16} />
                    </button>
                  </>
                )}

                {/* Re-check every lead against CURRENT salesperson pincode ownership */}
                <button
                  type="button"
                  className="sl-iconbtn primary"
                  title="Check all leads and assign/reassign them to the current owner of each pincode"
                  onClick={autoAssignAllLeads}
                  disabled={autoAssigning || !allRows.length}
                  style={{
                    width: "auto",
                    minWidth: 104,
                    padding: "0 10px",
                    gap: 6,
                    opacity: autoAssigning || !allRows.length ? 0.55 : 1,
                    cursor:
                      autoAssigning || !allRows.length
                        ? "not-allowed"
                        : "pointer",
                    fontSize: 11,
                    fontWeight: 900,
                  }}
                >
                  <FaCheck size={13} />
                  {autoAssigning ? "Checking..." : "Auto Assign"}
                </button>

                {/* assignment actions appear when one or more leads are selected */}
                {selectedIds.length > 0 && (
                  <>
                    <button
                      type="button"
                      className="sl-iconbtn"
                      title="Assign selected leads"
                      onClick={() => assignSelected(false)}
                    >
                      A
                    </button>
                    <button
                      type="button"
                      className="sl-iconbtn"
                      title="Unassign selected leads"
                      onClick={() => assignSelected(true)}
                    >
                      U
                    </button>
                  </>
                )}

                {permissions?.Delete && (
                  <>
                    <button
                      type="button"
                      className="sl-iconbtn danger"
                      title={
                        selectedIds.length > 0
                          ? `Delete Selected (${selectedIds.length})`
                          : "Select leads to bulk delete"
                      }
                      onClick={deleteBulk}
                      disabled={selectedIds.length === 0}
                      style={{
                        opacity: selectedIds.length === 0 ? 0.45 : 1,
                        cursor:
                          selectedIds.length === 0 ? "not-allowed" : "pointer",
                      }}
                    >
                      <Trash2 size={16} />
                    </button>

                    <button
                      type="button"
                      className="sl-iconbtn danger"
                      title={`Delete All (${allRows.length})`}
                      onClick={deleteAllLeads}
                      disabled={!allRows.length}
                      style={{
                        width: "auto",
                        minWidth: 82,
                        padding: "0 10px",
                        gap: 6,
                        opacity: allRows.length ? 1 : 0.45,
                        cursor: allRows.length ? "pointer" : "not-allowed",
                        fontSize: 11,
                        fontWeight: 900,
                      }}
                    >
                      <Trash2 size={14} />
                      Delete All
                    </button>
                  </>
                )}
              </div>

              {/* ✅ optional small info line (no messages, just info) */}
              {unassignedCount > 0 && (
                <div
                  style={{
                    padding: "0 12px 10px",
                    fontWeight: 800,
                    color: "#6b7280",
                    fontSize: 12,
                  }}
                >
                  Unassigned leads: {unassignedCount}
                </div>
              )}
            </Card>
          </Col>
        </Row>
      </div>

      {/* BODY */}
      <Row>
        <Col sm="12">
          {activeTab === "requested" ? (
            <RequestedTab
              requestTypeTab={requestTypeTab}
              setRequestTypeTab={setRequestTypeTab}
              leadCreationRequests={leadCreationRequests}
              conversionRequests={conversionRequests}
              search={debouncedSearch}
              openRequestReview={openRequestReview}
              openConversionEdit={openConversionEdit}
            />
          ) : (
            <>
              <LeadsTab
                rows={paginatedRows}
                visibleCols={visibleCols}
                selectedIds={selectedIds}
                toggleSelected={toggleSelected}
                openEdit={openEdit}
              />

              <div
                style={{
                  marginTop: 10,
                  padding: "8px 10px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 12,
                  background: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 10,
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ fontSize: 12, fontWeight: 800, color: "#475569" }}
                >
                  Showing {showingFrom}-{showingTo} of {filteredRows.length}
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 12, fontWeight: 800 }}>Rows</span>
                  <Input
                    type="select"
                    value={pageSize}
                    onChange={(e) => {
                      setPageSize(Number(e.target.value) || 50);
                      setCurrentPage(1);
                    }}
                    style={{ width: 82, height: 32, padding: "4px 8px" }}
                  >
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                  </Input>

                  <Button
                    size="sm"
                    color="light"
                    disabled={currentPage <= 1}
                    onClick={() => setCurrentPage(1)}
                  >
                    First
                  </Button>
                  <Button
                    size="sm"
                    color="light"
                    disabled={currentPage <= 1}
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                  >
                    Prev
                  </Button>

                  <span
                    style={{
                      minWidth: 92,
                      textAlign: "center",
                      fontSize: 12,
                      fontWeight: 900,
                    }}
                  >
                    {currentPage} / {totalPages}
                  </span>

                  <Button
                    size="sm"
                    color="light"
                    disabled={currentPage >= totalPages}
                    onClick={() =>
                      setCurrentPage((p) => Math.min(totalPages, p + 1))
                    }
                  >
                    Next
                  </Button>
                  <Button
                    size="sm"
                    color="light"
                    disabled={currentPage >= totalPages}
                    onClick={() => setCurrentPage(totalPages)}
                  >
                    Last
                  </Button>
                </div>
              </div>
            </>
          )}
        </Col>
      </Row>

      {/* ===== Edit Lead Modal (same as your current) ===== */}
      <Modal
        isOpen={editModal}
        toggle={() => setEditModal(false)}
        style={{ maxWidth: 920 }}
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader toggle={() => setEditModal(false)}>
          Edit Lead {editBadge()}
        </ModalHeader>
        <ModalBody>
          {editLoading ? (
            <div style={{ padding: 16, textAlign: "center" }}>
              <Spinner /> Loading...
            </div>
          ) : (
            <>
              <Row>
                <Col md="6">
                  <Label className="mb-1">Company *</Label>
                  <Input
                    value={editForm.CompanyName}
                    onChange={(e) =>
                      setEditForm((p) => ({
                        ...p,
                        CompanyName: e.target.value,
                      }))
                    }
                    placeholder="Enter company name"
                  />
                </Col>
                <Col md="6">
                  <Label className="mb-1">Mobile</Label>
                  <Input
                    value={editForm.mobileNumber}
                    onChange={(e) =>
                      setEditForm((p) => ({
                        ...p,
                        mobileNumber: e.target.value,
                      }))
                    }
                    placeholder="Enter mobile (optional)"
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md="12">
                  <Label className="mb-1">Address</Label>
                  <Input
                    value={editForm.address}
                    onChange={(e) =>
                      setEditForm((p) => ({ ...p, address: e.target.value }))
                    }
                    placeholder="Enter address"
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md="4">
                  <Label className="mb-1">Pincode *</Label>
                  <Input
                    value={editForm.pincode}
                    onChange={(e) =>
                      setEditForm((p) => ({ ...p, pincode: e.target.value }))
                    }
                    placeholder="Enter pincode"
                  />
                </Col>
                <Col md="4">
                  <Label className="mb-1">City</Label>
                  <Input
                    value={editForm.City}
                    onChange={(e) =>
                      setEditForm((p) => ({ ...p, City: e.target.value }))
                    }
                    placeholder="Enter city"
                  />
                </Col>
                <Col md="4">
                  <Label className="mb-1">State</Label>
                  <Input
                    value={editForm.State}
                    onChange={(e) =>
                      setEditForm((p) => ({ ...p, State: e.target.value }))
                    }
                    placeholder="Enter state"
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md="12">
                  <Label className="mb-1">Assign Sales Person (optional)</Label>
                  <Multiselect
                    className="cssformulti"
                    selectionLimit={1}
                    options={salesPeople}
                    selectedValues={
                      editForm.created_by
                        ? salesPeople.filter(
                            (x) =>
                              String(x?._id) === String(editForm.created_by),
                          )
                        : []
                    }
                    onSelect={(_, item) =>
                      setEditForm((p) => ({
                        ...p,
                        created_by: item?._id || "",
                      }))
                    }
                    onRemove={() =>
                      setEditForm((p) => ({ ...p, created_by: "" }))
                    }
                    displayValue="fullName"
                  />
                </Col>
              </Row>

              <Row className="mt-2">
                <Col md="6">
                  <Label className="mb-1">Last Activity Date</Label>
                  <Input
                    value={lastActivityDateTime(editRow).date}
                    disabled
                    style={{ background: "#f4f7f6" }}
                  />
                </Col>
                <Col md="6">
                  <Label className="mb-1">Last Activity Time</Label>
                  <Input
                    value={lastActivityDateTime(editRow).time}
                    disabled
                    style={{ background: "#f4f7f6" }}
                  />
                </Col>
              </Row>

              <div className="sl-remarks-wrap">
                <div className="sl-remarks-head">
                  <div style={{ fontWeight: 900, textTransform: "uppercase" }}>
                    Remark History
                  </div>
                  <div style={{ fontWeight: 900, color: "#0b5bf5" }}>
                    {remarkHistory.length} Total
                  </div>
                </div>

                {remarkHistory.length === 0 ? (
                  <div style={{ color: "#6b7280", fontWeight: 700 }}>
                    No follow-up remarks yet.
                  </div>
                ) : (
                  <div className="sl-remarks-list">
                    {remarkHistoryNewestFirst.map((rm, idx) => (
                      <div className="sl-remark-item" key={idx}>
                        <div className="sl-remark-ts">
                          {toStr(rm?.date)} {toStr(rm?.time)}
                        </div>
                        <div className="sl-remark-text">
                          {toStr(rm?.remark)}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="sl-modal-actions">
                {permissions?.Edit && (
                  <button
                    className="sl-btn sl-btn-follow"
                    type="button"
                    onClick={saveEdit}
                  >
                    Save Changes
                  </button>
                )}

                <button
                  className="sl-btn sl-btn-follow"
                  type="button"
                  onClick={() => setShowRemarkBox((p) => !p)}
                  title="Add follow up remark"
                >
                  Follow Up
                </button>

                <button
                  className="sl-btn sl-btn-reject"
                  type="button"
                  onClick={() => setLeadStatusAndGo("rejected")}
                  title="Reject lead"
                >
                  Rejected
                </button>

                {permissions?.Delete && (
                  <button
                    className="sl-btn sl-btn-delete"
                    type="button"
                    onClick={() =>
                      deleteOne(editRow?._id, () => {
                        setEditModal(false);
                      })
                    }
                    title="Delete lead"
                  >
                    <Trash2 size={16} />
                    Delete
                  </button>
                )}
              </div>

              {showRemarkBox && (
                <div
                  style={{
                    marginTop: 14,
                    border: "1px solid #e5e7eb",
                    borderRadius: 14,
                    padding: 12,
                    background: "#f9fafb",
                  }}
                >
                  <Label className="mb-1" style={{ fontWeight: 900 }}>
                    Follow Up Remark
                  </Label>
                  <Input
                    type="textarea"
                    rows="3"
                    value={remarkText}
                    onChange={(e) => setRemarkText(e.target.value)}
                    placeholder="Write remark..."
                    style={{ background: "#fff" }}
                  />
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      justifyContent: "center",
                      marginTop: 10,
                    }}
                  >
                    <Button
                      type="button"
                      color="secondary"
                      onClick={() => {
                        setShowRemarkBox(false);
                        setRemarkText("");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="button"
                      color="primary"
                      onClick={saveFollowUpRemark}
                    >
                      Save Remark
                    </Button>
                  </div>
                </div>
              )}
            </>
          )}
        </ModalBody>
      </Modal>

      {/* ===== SuperAdmin Request Review Modal ===== */}
      <Modal
        isOpen={requestReviewModal}
        toggle={() => {
          if (!requestReviewLoading) setRequestReviewModal(false);
        }}
        style={{ maxWidth: 1180, width: "96%" }}
        backdrop="static"
        keyboard={false}
      >
        <ModalHeader
          toggle={() => {
            if (!requestReviewLoading) setRequestReviewModal(false);
          }}
        >
          {requestReview?.kind === "conversion"
            ? "Customer Conversion Request"
            : "Lead Creation Request"}
        </ModalHeader>
        <ModalBody>
          {requestReview?.row ? (
            <>
              {requestReview?.kind === "conversion" ? (
                <ConversionFullDetails row={requestReview.row} />
              ) : (
                <div className="sl-detail-section">
                  <div className="sl-detail-section-title">
                    Lead Creation Request Details
                  </div>
                  <div className="sl-detail-grid-three">
                    <DetailItem
                      label="Company"
                      value={requestReview.row?.CompanyName}
                    />
                    <DetailItem
                      label="Mobile"
                      value={requestReview.row?.mobileNumber}
                    />
                    <DetailItem
                      label="Pincode"
                      value={requestReview.row?.pincode}
                    />
                    <DetailItem label="City" value={requestReview.row?.City} />
                    <DetailItem
                      label="State"
                      value={requestReview.row?.State}
                    />
                    <DetailItem
                      label="Sales Person"
                      value={
                        requestReview.row?.requestedByName || "Sales Person"
                      }
                    />
                    <DetailItem
                      label="Status"
                      value={requestReview.row?.status || "Pending"}
                    />
                    <DetailItem
                      label="Requested At"
                      value={formatDateTime(requestReview.row?.createdAt)}
                    />
                    <DetailItem
                      label="Reviewed At"
                      value={formatDateTime(requestReview.row?.reviewedAt)}
                    />
                    <DetailItem
                      label="Reviewed By"
                      value={requestReview.row?.reviewedBy}
                    />
                    <DetailItem
                      label="Address"
                      value={requestReview.row?.address}
                      full
                    />
                    <DetailItem
                      label="Review Remark"
                      value={requestReview.row?.reviewRemark}
                      full
                    />
                  </div>
                </div>
              )}

              <div style={{ marginTop: 14 }}>
                <Label style={{ fontWeight: 900 }}>
                  SuperAdmin Review Remark
                </Label>
                <Input
                  type="textarea"
                  rows="3"
                  placeholder="Write approval / rejection remark..."
                  value={requestReview?.remark || ""}
                  onChange={(e) =>
                    setRequestReview((prev) => ({
                      ...prev,
                      remark: e.target.value,
                    }))
                  }
                  disabled={requestReviewLoading}
                />
              </div>

              {requestReview?.kind === "conversion" &&
                String(
                  requestReview.row?.conversionStatus || "",
                ).toLowerCase() === "pending verification" && (
                  <Alert
                    color="warning"
                    style={{ marginTop: 12, marginBottom: 0 }}
                  >
                    This salesperson has saved customer-conversion details, but
                    the lead mobile OTP has not been verified yet. SuperAdmin
                    cannot approve the conversion until it becomes{" "}
                    <b>Waiting</b>.
                  </Alert>
                )}

              <div className="sl-modal-actions" style={{ marginTop: 16 }}>
                <Button
                  type="button"
                  color="secondary"
                  disabled={requestReviewLoading}
                  onClick={() => setRequestReviewModal(false)}
                >
                  Close
                </Button>

                {requestReview?.kind === "leadCreation" &&
                  String(requestReview.row?.status || "").toLowerCase() ===
                    "pending" && (
                    <>
                      <Button
                        type="button"
                        color="success"
                        disabled={requestReviewLoading}
                        onClick={() => submitRequestDecision("Approved")}
                      >
                        {requestReviewLoading ? "Saving..." : "Approve Request"}
                      </Button>
                      <Button
                        type="button"
                        color="danger"
                        disabled={requestReviewLoading}
                        onClick={() => submitRequestDecision("Rejected")}
                      >
                        {requestReviewLoading ? "Saving..." : "Reject Request"}
                      </Button>
                    </>
                  )}

                {requestReview?.kind === "conversion" &&
                  String(
                    requestReview.row?.conversionStatus || "",
                  ).toLowerCase() === "waiting" && (
                    <Button
                      type="button"
                      color="info"
                      disabled={requestReviewLoading}
                      onClick={() => openConversionEdit(requestReview.row)}
                    >
                      Edit Customer Details
                    </Button>
                  )}

                {requestReview?.kind === "conversion" &&
                  String(
                    requestReview.row?.conversionStatus || "",
                  ).toLowerCase() === "waiting" && (
                    <>
                      <Button
                        type="button"
                        color="success"
                        disabled={requestReviewLoading}
                        onClick={() => submitRequestDecision("Approved")}
                      >
                        {requestReviewLoading
                          ? "Saving..."
                          : "Approve as Customer"}
                      </Button>
                      <Button
                        type="button"
                        color="danger"
                        disabled={requestReviewLoading}
                        onClick={() => submitRequestDecision("Rejected")}
                      >
                        {requestReviewLoading
                          ? "Saving..."
                          : "Reject Conversion"}
                      </Button>
                    </>
                  )}
              </div>
            </>
          ) : (
            <div style={{ padding: 20, textAlign: "center" }}>
              No request selected.
            </div>
          )}
        </ModalBody>
      </Modal>

      {/* ===== Column Chooser Modal ===== */}
      <Modal
        isOpen={colsModal}
        toggle={() => setColsModal(false)}
        zIndex={2000}
        backdrop="static"
        keyboard={false}
        style={{ maxWidth: 1050 }}
      >
        <ModalHeader toggle={() => setColsModal(false)}>
          Change Fields
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="4" md="4" sm="12" xl="4" xs="12">
              <h5>Available Columns</h5>
              <div style={listBoxStyle}>
                {BASE_COLS.filter((c) => c.key !== "__check__").map((col) => (
                  <div key={col.key} style={pickItemStyle}>
                    <label
                      style={{ display: "flex", alignItems: "center", gap: 8 }}
                    >
                      <input
                        type="checkbox"
                        onChange={(e) =>
                          handleCheckbox(e.target.checked, col.key)
                        }
                      />
                      <span>{col.header}</span>
                    </label>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: 8 }}>
                <Button size="sm" color="primary" onClick={addSelectedColumns}>
                  Add Selected →
                </Button>
              </div>
            </Col>

            <Col lg="8" md="8" sm="12" xl="8" xs="12">
              <h5>Visible Columns</h5>
              <div
                style={{ display: "flex", gap: 12, alignItems: "flex-start" }}
              >
                <div style={{ ...listBoxStyle, flex: 1 }}>
                  {selectedKeys.map((key, i) => {
                    const col = colMap.get(key);
                    if (!col) return null;
                    return (
                      <div
                        key={key}
                        style={{
                          ...pickItemStyle,
                          background: i === selectedIndex ? "#1877f2" : "#fff",
                          color: i === selectedIndex ? "#fff" : "#000",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedIndex(i)}
                      >
                        {col.header}
                      </div>
                    );
                  })}
                </div>
                <div style={{ display: "grid", gap: 8 }}>
                  <Button size="sm" onClick={shiftUp}>
                    ↑
                  </Button>
                  <Button size="sm" onClick={shiftDown}>
                    ↓
                  </Button>
                  <Button size="sm" color="danger" onClick={removeAtIndex}>
                    Remove
                  </Button>
                </div>
              </div>
              <div style={{ marginTop: 12, textAlign: "center" }}>
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    localStorage.setItem(
                      "SalesLeadCols",
                      JSON.stringify(selectedKeys),
                    );
                    setColsModal(false);
                  }}
                >
                  Submit
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>

      {/* ===== Upload Modal ===== */}
      <Modal
        isOpen={uploadModal}
        toggle={() => {
          if (!uploading) {
            setUploadModal(false);
            resetUploadProgress();
          }
        }}
        style={{ maxWidth: 720 }}
        backdrop={uploading ? "static" : true}
        keyboard={!uploading}
      >
        <ModalHeader
          toggle={
            uploading
              ? undefined
              : () => {
                  setUploadModal(false);
                  resetUploadProgress();
                }
          }
        >
          Upload Leads
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={submitUpload}>
            <Row className="mb-2">
              <Col className="d-flex align-items-center gap-2">
                <Label className="mb-0">
                  Choose Type <span style={{ color: "red" }}>*</span>
                </Label>
                <div
                  onChange={(e) => {
                    if (!uploading) setUploadType(e.target.value);
                  }}
                >
                  <input
                    type="radio"
                    name="UploadStatus"
                    value="New Upload"
                    checked={uploadType === "New Upload"}
                    disabled={uploading}
                    style={{ marginRight: 6 }}
                  />
                  <span style={{ marginRight: 16 }}>New Upload</span>
                  <input
                    type="radio"
                    name="UploadStatus"
                    value="Update"
                    checked={uploadType === "Update"}
                    disabled={uploading}
                    style={{ marginRight: 6 }}
                  />
                  <span>Update</span>
                </div>
              </Col>
            </Row>

            <div style={uploadBox}>
              <div style={{ fontSize: 18, color: "#065f46", fontWeight: 700 }}>
                {uploading ? "Bulk upload in progress" : "Click to select file"}
              </div>
              <input
                required
                type="file"
                name="file"
                accept=".xlsx,.csv"
                disabled={uploading}
                onChange={(e) => {
                  setUploadFile(e.target.files?.[0] || null);
                  resetUploadProgress();
                }}
              />
            </div>

            {(uploading || uploadProgress.total > 0) && (
              <div
                style={{
                  marginTop: 14,
                  border: "1px solid #dbe3ea",
                  borderRadius: 14,
                  padding: 14,
                  background: "#f8fafc",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <div style={{ fontWeight: 950, color: "#0f172a" }}>
                    Live Upload Progress
                  </div>
                  <div style={{ fontWeight: 950, color: "#0b5bf5" }}>
                    {uploadProgress.processed}/{uploadProgress.total || 0} rows
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    height: 10,
                    borderRadius: 999,
                    background: "#e5e7eb",
                    overflow: "hidden",
                  }}
                >
                  <div
                    style={{
                      width: `${
                        uploadProgress.total
                          ? Math.min(
                              100,
                              Math.round(
                                (uploadProgress.processed /
                                  uploadProgress.total) *
                                  100,
                              ),
                            )
                          : 0
                      }%`,
                      height: "100%",
                      background: "#0b5bf5",
                      transition: "width .25s ease",
                    }}
                  />
                </div>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                    gap: 8,
                    marginTop: 12,
                  }}
                >
                  <div className="sl-detail-item">
                    <div className="sl-detail-label">Inserted</div>
                    <div className="sl-detail-value">
                      {uploadProgress.inserted}
                    </div>
                  </div>
                  <div className="sl-detail-item">
                    <div className="sl-detail-label">Auto Assigned</div>
                    <div className="sl-detail-value">
                      {uploadProgress.assigned}
                    </div>
                  </div>
                  <div className="sl-detail-item">
                    <div className="sl-detail-label">Duplicates</div>
                    <div className="sl-detail-value">
                      {uploadProgress.duplicates}
                    </div>
                  </div>
                  <div className="sl-detail-item">
                    <div className="sl-detail-label">Unassigned</div>
                    <div className="sl-detail-value">
                      {uploadProgress.unassigned}
                    </div>
                  </div>
                  <div className="sl-detail-item">
                    <div className="sl-detail-label">Invalid</div>
                    <div className="sl-detail-value">
                      {uploadProgress.invalid}
                    </div>
                  </div>
                  <div className="sl-detail-item">
                    <div className="sl-detail-label">Batch</div>
                    <div className="sl-detail-value">
                      {uploadProgress.batch}/{uploadProgress.batches || 0}
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: 10,
                    fontSize: 11,
                    fontWeight: 800,
                    color: "#64748b",
                  }}
                >
                  Progress updates after each fast 500-row batch has actually
                  been processed by the backend.
                </div>
              </div>
            )}

            <Row className="mt-2">
              <Col className="d-flex justify-content-center">
                <Button
                  color="primary"
                  type="submit"
                  className="mt-1"
                  disabled={uploading}
                >
                  {uploading
                    ? `Uploading ${uploadProgress.processed}/${
                        uploadProgress.total || 0
                      }`
                    : "Import"}
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {/* ✅ Create Lead Modal */}
      <Modal
        isOpen={createLeadModal}
        toggle={() => setCreateLeadModal(false)}
        style={{ maxWidth: 820 }}
      >
        <ModalHeader toggle={() => setCreateLeadModal(false)}>
          Create Lead
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={submitCreateLead}>
            <Row>
              <Col md="6">
                <Label className="mb-1">Company *</Label>
                <Input
                  value={createLead.CompanyName}
                  onChange={(e) =>
                    setCreateLead((p) => ({
                      ...p,
                      CompanyName: e.target.value,
                    }))
                  }
                  placeholder="Enter company name"
                  required
                />
              </Col>
              <Col md="6">
                <Label className="mb-1">Mobile</Label>
                <Input
                  value={createLead.mobileNumber}
                  onChange={(e) =>
                    setCreateLead((p) => ({
                      ...p,
                      mobileNumber: e.target.value,
                    }))
                  }
                  placeholder="Enter mobile (optional)"
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md="12">
                <Label className="mb-1">Address</Label>
                <Input
                  value={createLead.address}
                  onChange={(e) =>
                    setCreateLead((p) => ({ ...p, address: e.target.value }))
                  }
                  placeholder="Enter address"
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md="4">
                <Label className="mb-1">Pincode *</Label>
                <Input
                  value={createLead.pincode}
                  onChange={(e) => {
                    const pin = e.target.value;
                    setCreateLead((p) => ({ ...p, pincode: pin }));
                    const clean = String(pin || "").trim();
                    if (clean.length >= 6) {
                      const sp = findSalesPersonByPincode(clean);
                      setAutoSalesPerson(sp || null);
                    } else {
                      setAutoSalesPerson(null);
                    }
                  }}
                  placeholder="Enter pincode"
                  required
                />
              </Col>
              <Col md="4">
                <Label className="mb-1">City</Label>
                <Input
                  value={createLead.City}
                  onChange={(e) =>
                    setCreateLead((p) => ({ ...p, City: e.target.value }))
                  }
                  placeholder="Enter city"
                />
              </Col>
              <Col md="4">
                <Label className="mb-1">State</Label>
                <Input
                  value={createLead.State}
                  onChange={(e) =>
                    setCreateLead((p) => ({ ...p, State: e.target.value }))
                  }
                  placeholder="Enter state"
                />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col md="12">
                <Label className="mb-1">Auto Sales Person (by pincode)</Label>
                <Input
                  value={
                    autoSalesPerson ? autoSalesPerson.fullName : "Not Found"
                  }
                  disabled
                  style={{
                    background: "#f4f7f6",
                    fontWeight: 700,
                    color: autoSalesPerson ? "#065f46" : "#b91c1c",
                  }}
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col
                className="d-flex justify-content-center"
                style={{ gap: 10 }}
              >
                <Button
                  type="button"
                  color="secondary"
                  onClick={() => setCreateLeadModal(false)}
                >
                  Cancel
                </Button>
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
}

/* ---- little styles ---- */
const listBoxStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 10,
  maxHeight: 280,
  overflow: "auto",
  background: "#fff",
  padding: 8,
};
const pickItemStyle = {
  padding: "8px 10px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  marginBottom: 6,
  background: "#fff",
};
const uploadBox = {
  border: "1px dashed #aaa",
  borderRadius: 12,
  padding: 16,
  textAlign: "center",
  background: "#f9fafb",
};
